import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Type, ViewChild } from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { ReportKindInfo } from "projects/sepidz-web-framework-data-grid/src/lib/report-kind";
import { ReportCopyComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-copy.component";
import { ReportSelectorComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-selector.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { DetailLedger, form_control, SaveReportFile } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { IncrementalKind, InvStatusKind, RowState, SystemKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { GridFilter, isNullOrUndefined, isNumber, LookupService, PagingDataResult, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { BehaviorSubject, Observable } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AccVoucherFormComponent } from "src/app/backoffice/acc/accvoucher/accvoucher-form/accvoucher-form.component";
import { SellVoucherDetail } from "src/app/backoffice/sell/models/sell-voucher-detail.model";
import { SellVoucherHeader } from "src/app/backoffice/sell/models/sell-voucher-header.model";
import { FormOperationKind } from "../../models/form-operation-kind.enums";
import { GoodsFormulaDetail } from "../../models/goods-formula-detail.model";
import { Goods } from "../../models/goods.model";
import { InvVoucherDetail } from "../../models/inv-voucher-detail.model";
import { InvVoucherGoodsSimilarRelation } from "../../models/inv-voucher-goods-similar-relation.model";
import { InvVoucherHeader } from "../../models/inv-voucher-header.model";
import { InvVoucherKind, ReferenceVoucherKind } from "../../models/inv-voucher-kind.model";
import { ReferenceVoucherByVoucherKindFilterInfo } from "../../models/reference-voucher-byvoucher-kind-filter-info.model";
import { StockInfo } from "../../models/stock-info.model";
import { InvVoucherModalListComponent } from "../inv-voucher-modal-list/inv-voucher-modal-list.component";
import { InvVoucherDetailComponent } from "../invvoucher-detail/invvoucher-detail.component";
@Component({
  selector: "ngx-invvoucher-form",
  templateUrl: "./invvoucher-form.component.html",
  styleUrls: ["./invvoucher-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvVoucherFormComponent extends BaseFormComponent<InvVoucherHeader> {
  @ViewChild("detail") public detail: InvVoucherDetailComponent;
  inputEditorform: Type<any>;
  CreatedVoucherKindReferencedTo: boolean = false;
  isCreatingAccVoucher: boolean = false;
  isDeleteCreatingAccVoucher: boolean = false;
  isLoadingReferenceVoucherKind: boolean = false;
  currentVoucherKind: InvVoucherKind;
  StockInfoColumns: form_control[];
  DiscountColumns: form_control[];
  InvVoucherDetailColumns: form_control[];
  rightSideColumns: form_control[];
  bodyColumns: form_control[];
  subLedgerColumns: form_control[];
  leftSideColumns: form_control[];
  stockList: StockInfo[] = [];
  stockListLoaded: BehaviorSubject<boolean>;
  filterdDataList: StockInfo[] = [];
  InvBalanceColumnswidth: number = 100;
  goodsFormulaDetailList: GoodsFormulaDetail[];
  ReportGoodsFormulaDetailList: GoodsFormulaDetail[];
  ReferenceToVoucherKinds: InvVoucherKind[];
  CurrentReferenceToVoucherKindId: number;
  CurrentGoodsList: Goods[];
  OrignalDetail: InvVoucherDetail[];
  isValidating: boolean = false;
  isOkForLoad: boolean = false;
  hasPriceRefresh: boolean = false;
  isNewVoucher: boolean = false;
  erroremessage: string;
  isloading: boolean = false;
  goodsError: boolean = false;
  maxCodeLoading: boolean = false;
  voucherConfirmDisable: boolean = false;
  confirmLabel: string;
  accVoucherCaption: string;
  currentReport: string;
  reportList: SaveReportFile[];
  reportKinds = ReportKindInfo.reportKinds;
  isFristReplaceGoodsSimilar: boolean = true;
  isRefreshingData: boolean = false;
  footerColumns: form_control[];
  transportColumns: form_control[];
  filterLookUp: any[] = [{ key: "Quarantine", value: false }];
  isNonValidEdit: boolean = true;
  @HostListener("window:keydown", ["$event"])
  cs(e: KeyboardEvent) {
    if (document.hidden) return;
    if (e.ctrlKey && e.shiftKey && !e.altKey && (e.key.toUpperCase() === "P" || e.key === "ح" || e.key === "\\")) {
      e.preventDefault();
      this.currentReport = "preview";
      this.changeReport("preview");
    }
    if (e.ctrlKey && e.altKey && !e.shiftKey && (e.key.toUpperCase() === "P" || e.key === "ح")) {
      e.preventDefault();
      this.currentReport = "editReport";
      this.changeReport("editReport");
    }
    if (e.ctrlKey && !e.altKey && !e.shiftKey && (e.key.toUpperCase() === "P" || e.key === "ح")) {
      e.preventDefault();
      this.currentReport = "print";
      this.changeReport("print");
    }
    if (e.ctrlKey && (e.key.toUpperCase() === "N" || e.key === "د")) {
      e.preventDefault();
      this.newVoucher();
    }
    if (e.ctrlKey && (e.key.toUpperCase() === "D" || e.key === "ی" || e.key === "ی")) {
      e.preventDefault();
      this.deleteVoucher();
    }
    if (e.ctrlKey && e.shiftKey && (e.key.toUpperCase() === "S" || e.key === "س")) {
      e.preventDefault();
      this.voucherConfirm();
    }
    if (e.ctrlKey && (e.key.toUpperCase() === "R" || e.key === "ق")) {
      e.preventDefault();
      this.ngOnInit().then();
    }
  }
  constructor(
    private lookupservice: LookupService,
    private splashFormService: SplashFormService,
    private missetup: MisSetupService,
    protected selectorService: SelectorService,
    __id: FormContainerModel,
    _tabsservice: TabularService,
    protected cd: ChangeDetectorRef,
    private datatransfer: Datatransfer,
    _VoucherKindInfo: VoucherKindInfo
  ) {
    super(selectorService, cd);
    this.NoMaxCode = true;

    this._id = __id;
    this.currentrow = this.datatransfer?.currentrow;
    if (this.datatransfer?.apiName) this.apiName = this.datatransfer?.apiName.split("/")[0];
    if (this.datatransfer?.areaName) this.areaName = this.datatransfer?.areaName;
    this.VoucherKind = _VoucherKindInfo;
    this.tabsservice = _tabsservice;
    this.currentFiscalYear;
    this.onDataStateChange = this.onDataStateChange.bind(this);
    this.onReferenceVoucherChange = this.onReferenceVoucherChange.bind(this);
    this.stockListLoaded = new BehaviorSubject<boolean>(false);
  }
  get headerTitleToDetailTitle(): string {
    return this.formGroup?.controls["Comment"].value;
  }
  get detailLedgerLevel(): number {
    const lvl = this.missetup.getnumber("ACC", "DLLEVEL");
    return lvl;
  }
  get filterEntity() {
    let entity: ReferenceVoucherByVoucherKindFilterInfo = <ReferenceVoucherByVoucherKindFilterInfo>{};
    entity.FiscalYearId = this.currentFiscalYear.Id;
    entity.DetailLedgerId = this.formGroup?.controls["DetailLedgerId"] ? this.formGroup?.controls["DetailLedgerId"].value : null;
    entity.WarehouseId = this.formGroup?.controls["WarehouseId"] ? this.formGroup?.controls["WarehouseId"].value : null;
    entity.ReferencedVoucherKindId = this.formGroup?.controls["ReferenceVoucherKindId"]
      ? this.formGroup?.controls["ReferenceVoucherKindId"].value
      : null;
    entity.VoucherDate = this.formGroup?.controls["VoucherDate"] ? this.formGroup?.controls["VoucherDate"].value : null;
    entity.VoucherKindId = this.formGroup?.controls["VoucherKindId"] ? this.formGroup?.controls["VoucherKindId"].value : null;
    entity.WarehouseTransferId = this.formGroup?.controls["WarehouseTransferId"] ? this.formGroup?.controls["WarehouseTransferId"].value : null;
    return entity;
  }
  get ReferenceVoucherKindId() {
    if (this.formGroup && this.formGroup?.controls["ReferenceVoucherKindId"]) return this.formGroup?.controls["ReferenceVoucherKindId"].value;
    return undefined;
  }
  get IsPurchaseInvoice() {
    return this.currentVoucherKind !== undefined && this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseInvoice;
  }
  get IsReturnPurchaseInvoice() {
    return this.currentVoucherKind !== undefined && this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.IsReturnPurchaseInvoice;
  }

  get hasReference() {
    return (
      this.currentVoucherKind !== undefined &&
      this.currentVoucherKind?.ReferenceVoucherKinds !== undefined &&
      this.currentVoucherKind?.ReferenceVoucherKinds.length > 0
    );
  }
  get hasReferenceRequired() {
    return (
      this.currentVoucherKind !== undefined &&
      this.currentVoucherKind?.ReferenceVoucherKinds !== undefined &&
      this.currentVoucherKind?.ReferenceVoucherKindIsRequired
    );
  }
  get currentFiscalYear() {
    return this.accountService?.authService?.currentFiscalYear;
  }
  get hasTaxDuty() {
    return this.currentVoucherKind && this.currentVoucherKind?.HasTaxDuty;
  }
  get hasDiscount() {
    return this.currentVoucherKind && this.currentVoucherKind?.HasDiscount;
  }
  get Priceable() {
    return this.currentVoucherKind && this.currentVoucherKind?.Priceable;
  }
  get ShowStockAmount() {
    this.InvBalanceColumnswidth = 65 + (!this.HasTransportInterface ? 15 : 0) + (!this.Priceable ? 15 : 0);
    return this.currentVoucherKind && this.currentVoucherKind?.ShowStockAmount;
  }
  get getGridHeight() {
    return this.Priceable === true || this.HasTransportInterface === true || this.ShowStockAmount == true ? 35 : 60;
  }
  setlocalColumns() {
    var col = this.orignalColumns?.filter((f) => f.formVisible && f.areaName === "Footer");
    this.footerColumns = col.sort((a, b) => a.order - b.order);
    var col = this.orignalColumns?.filter((f) => f.formVisible && (f.areaName === "Transport" || f.areaName === "Discount"));
    this.transportColumns = col.sort((a, b) => a.order - b.order);

    var col = this.orignalColumns?.filter((f) => f.formVisible && f.areaName === "Discount");
    this.DiscountColumns = col.sort((a, b) => a.order - b.order);
  }
  get HasJournalVoucher() {
    return this.currentVoucherKind?.HasJournalVoucher;
  }
  get HasTransportInterface() {
    return this.currentVoucherKind && this.currentVoucherKind?.HasTransportInterface;
  }
  setReferenceVoucherColumn() {
    this.httpCommonService
      .get("InvVoucherHeader/GetReferenceVoucherInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: form_control[]) => {
          this.selectorService.setColumns("ReferenceId", data);
        },
        (error) => this.getFailedHelper(error)
      );
  }
  async ngOnInit() {
    this.isNewVoucher = false;
    if (this.currentrow && this.currentrow["VoucherHeaderId"]) this.currentrow.Id = this.currentrow["VoucherHeaderId"];

    if (this.detail !== undefined)
      setTimeout(() => {
        this.detail.setColumns();
      }, 100);
    this.filterdDataList = [];
    this.apiName = "InvVoucherHeader";
    this.areaName = "Inventory";
    if (this.currentrow && (this.currentrow as InvVoucherHeader).VoucherKindTitle) {
      this.label = (this.currentrow as InvVoucherHeader).VoucherKindTitle + `(${(this.currentrow as InvVoucherHeader).VoucherNo})`;
      this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
      this.model.ReferenceVoucherKindCode = this.currentrow.ReferenceVoucherKindCode;
    }
    if (this.ShowStockAmount) this.setStockInfoColumns();

    this.ReportSelectorForm = ReportSelectorComponent;
    this.ReportCopyForm = ReportCopyComponent;
    this.pathPreFix = `INV`;
    this.reportName = "InventoryDocument";
    this.setCurrentVoucherKind();
    await super.ngOnInit();
    this.loadReports();
    this.selectorService.submitted$.next(false);
    this.setReferenceVoucherColumn();
    this.GetGoodsFormulaDetail();
  }
  setStatusKind() {
    if (!this.model.StatusKindId) {
      this.lookupservice
        .getLookupbyCode("INV", "StatusKind", InvStatusKind.Registered)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            this.model.StatusKindId = x.Id;
            this.model.StatusKindCode = x.Code;
            this.model.StatusKindTitle = x.Title;
            this.setValue("StatusKindId", this.model.StatusKindId);
            this.setValue("StatusKindCode", this.model.StatusKindCode);
            this.setValue("StatusKindTitle", this.model.StatusKindTitle);
          }
        });
    }
  }
  setConfirmStatusKind() {
    this.lookupservice
      .getLookupbyCode("INV", "StatusKind", InvStatusKind.Confirmed)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (x) {
          this.model.StatusKindId = x.Id;
          this.model.StatusKindCode = x.Code;
          this.model.StatusKindTitle = x.Title;
          this.setValue("StatusKindId", this.model.StatusKindId);
          this.setValue("StatusKindCode", this.model.StatusKindCode);
          this.setValue("StatusKindTitle", this.model.StatusKindTitle);
        }
      });
  }
  setdefault() {
    if (this.model?.InvVoucherDetailList?.length > 0) this.OrignalDetail = Object.assign([], this.model.InvVoucherDetailList);
    if (this.model?.IsTakingOfInventory === undefined)
      this.model.IsTakingOfInventory = this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.IsTakingOfInventory;

    if (!this.model.SystemKindId) {
      this.lookupservice
        .getLookupbyCode("GNR", "SystemKind", SystemKind.INV)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.SystemKindId = x.Id;
          this.setValue("SystemKindId", x.Id);
        });
    }
    if (this.model.VoucherKindId) {
      this.VoucherKind = new VoucherKindInfo();
      this.VoucherKind.VoucherKindId = this.model.VoucherKindId;
      this.setCurrentVoucherKind();
    }
    if (!this.model.Invoicecredit) this.model.Invoicecredit = 0;
    if (!this.model.VoucherDate && this.currentVoucherKind && this.currentVoucherKind?.ToDayDate) {
      this.model.VoucherDate = new Date();
      this.setValue("VoucherDate", this.model.VoucherDate);
    }
    if (!this.model.InvVoucherDetailList) this.model.InvVoucherDetailList = [];

    if (!this.model.FiscalYearId && this.currentFiscalYear) {
      this.model.FiscalYearId = this.currentFiscalYear.Id;
      this.model.Year = this.currentFiscalYear.Year;
    } else if (!this.model.FiscalYearId) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.model.FiscalYearId = x.Id;
          this.model.Year = x.Year;
          this.setValue("FiscalYearId", x.Id);
          this.setValue("Year", x.Year);
        }
      });
    }
    if (!this.model.StatusKindId) {
      this.setStatusKind();
      this.confirmLabel = "تایید سند";
    }
    if (this.model.StatusKindCode >= InvStatusKind.Confirmed) this.confirmLabel = "برگشت از تایید";
    else this.confirmLabel = "تایید";

    if (!this.model.VoucherKindId && this.currentVoucherKind) {
      this.model.VoucherKindId = this.currentVoucherKind?.Id;
      this.model.VoucherKindCode = this.currentVoucherKind?.Code;
      this.model.VoucherKindTitle = this.currentVoucherKind?.Title;
    } else if (!this.model.VoucherKindId && this.VoucherKind.VoucherKindId) {
      this.model.VoucherKindId = this.VoucherKind.VoucherKindId;
    }
    if (!this.model.BranchId) {
      this.model.BranchId = this.accountService.authService.currentBranchId;
    }
    if (!this.model.SlaveNo) this.model.SlaveNo = 0;
    if (!this.model.SumDeduction) this.model.SumDeduction = 0;
    if (!this.model.SumPrice) this.model.SumPrice = 0;
    if (!this.model.SumSurplusage) this.model.SumSurplusage = 0;
    if (!this.model.TotalPrice) this.model.TotalPrice = 0;
    if (!this.model.TotalDeduction) this.model.TotalDeduction = 0;
    if (!this.model.TotalSurplusage) this.model.TotalSurplusage = 0;
    if (!this.model.DiscountAmount) this.model.DiscountAmount = 0;
    if (!this.model.Tax) this.model.Tax = 0;
    if (!this.model.TotalDeduction) this.model.TotalDeduction = 0;
    if (!this.model.TransportPrice) this.model.TransportPrice = 0;
    if (!this.model.TransportTax) this.model.TransportTax = 0;
    if (this.model.StatusKindCode === InvStatusKind.AccountRegistered) this.accVoucherCaption = "حذف سند حسابداری";
    else this.accVoucherCaption = "سند حسابداری";
    this.setDefaultValues();
    if (this.model?.InvVoucherDetailList?.length <= 0 && this.OrignalDetail?.length > 0) this.model.InvVoucherDetailList = this.OrignalDetail;
    if (this.detail && this.model && this.model?.InvVoucherDetailList && this.model?.InvVoucherDetailList?.length > 0) {
      this.model.InvVoucherDetailList.forEach((x) => (x.State = RowState.NoChange));
      this.detail.dataList = this.model.InvVoucherDetailList;
      this.detail.cd.markForCheck();
      console.log(this.detail.dataList);
      this.cd.markForCheck();

      this.detail.cd.markForCheck();
      if (!this.isNewRow && this.detail.dataList.some((x) => x.Id == 0)) {
        setTimeout(async () => {
          await this.ngOnInit();
        }, 50);
        //console.log(this.detail.dataList);
      }
    }
    if (this.detail && !this.isNewRow) this.detail.cancelHandler();

    if (!this.isNewRow && this.model?.VoucherKindId > 0) {
      try {
        this.setReferenceToVoucherKind().then();
      } catch (e) {
        console.log(e);
      }
    }
    setTimeout(() => {
      this.setAllUnTouched();
      // if (this.detail.dataList.some((x) => x.Id == 0)) {
        //console.log(this.detail.dataList);
      // }
    }, 200);
  }

  setMaxCode() {
    if (!this.isNewRow || this.maxCodeLoading) return;

    this.maxCodeLoading = true;
    if (this.currentFiscalYear) {
      var fiscalYearId = this.currentFiscalYear.Id;
      this.httpCommonService
        .getMaxCodeWithParameter(this.apiName, this.VoucherKind.VoucherKindId, fiscalYearId, this.model.WarehouseId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            if (!this.model) this.model = <InvVoucherHeader>{};
            if (data && data["VoucherNumber"]) {
              this.model["VoucherNo"] = data["VoucherNumber"] as number;
              if (this.formGroup?.get("VoucherDate")?.value && this.formGroup?.get("VoucherDate")?.value !== this.model["VoucherDate"])
                this.model["VoucherDate"] = this.formGroup?.get("VoucherDate")?.value;

              if (this.currentVoucherKind && this.currentVoucherKind?.ToDayDate && !this.formGroup?.get("VoucherDate")?.value) {
                this.model["VoucherDate"] = new Date();
              } else if (!this.model["VoucherDate"] && !this.formGroup?.get("VoucherDate")?.value)
                this.model["VoucherDate"] = data["VoucherDate"] as Date;
              if (this.currentVoucherKind.Code >= 1001 && this.currentVoucherKind.Code <= 1005) {
                const branch = this.accountService.authService.currentBranch;
                this.model.WarehouseId = branch.InvWarehouseId;
              }
              if (!this.formGroup) {
                this.setdefault();
                this.setFormGroup(this.model);
              } else {
                this.setValue("VoucherNo", data["VoucherNumber"] as number);
                this.setValue("VoucherDate", this.model["VoucherDate"]);
              }
            }
            this.maxCodeLoading = false;
          },
          (error) => (this.maxCodeLoading = false)
        );
    } else {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          var fiscalYearId = x.Id;
          this.httpCommonService
            .getMaxCodeWithParameter(this.apiName, this.VoucherKind.VoucherKindId, fiscalYearId, this.model.WarehouseId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data && data["VoucherNumber"]) {
                  this.model["VoucherNo"] = data["VoucherNumber"] as number;
                  if (this.currentVoucherKind && this.currentVoucherKind?.ToDayDate) this.model["VoucherDate"] = new Date();
                  else this.model["VoucherDate"] = data["VoucherDate"] as Date;
                  if (!this.formGroup) {
                    this.setdefault();
                    this.setFormGroup(this.model);
                  } else {
                    this.setValue("VoucherNo", data["VoucherNumber"] as number);
                    this.setValue("VoucherDate", data["VoucherDate"] as Date);
                  }
                }
                this.maxCodeLoading = false;
              },
              (error) => (this.maxCodeLoading = false)
            );
        }
      });
    }
  }
  onChange($event) {
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Warehouse") && $event.KeyName === "WarehouseId") {
      if (this.model.WarehouseCode !== $event.data.Code) this.setMaxCode();
      this.model.WarehouseCode = $event.data.Code;
      this.model.WarehouseTitle = $event.data.Title;
    }
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Warehouse") && $event.KeyName === "WarehouseTransferId") {
      this.model.WarehouseTransferCode = $event.data.Code;
      this.model.WarehouseTransferTitle = $event.data.Title;
    }

    this.isValid();
  }

  async setCurrentVoucherKind() {
    if (this.currentVoucherKind?.IncrementalKindCode > 0 && !this.VoucherKind?.VoucherKindId) return;
    await this.httpCommonService
      .getItem<InvVoucherKind>("InvVoucherKind", this.VoucherKind?.VoucherKindId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          try {
            if (data) {
              this.setValue("VoucherKindId", this.VoucherKind?.VoucherKindId);
              this.currentVoucherKind = Object.assign({}, data as InvVoucherKind);
              this.model.IsTakingOfInventory = this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.IsTakingOfInventory;
              this.model.Invoicecredit = this.currentVoucherKind?.Invoicecredit;
              this.setValue("Invoicecredit", this.model?.Invoicecredit);
              this.setValue("IsTakingOfInventory", this.model?.IsTakingOfInventory);
              this.model.VoucherKindId = this.currentVoucherKind?.Id;
              this.model.VoucherKindCode = this.currentVoucherKind?.Code;
              this.model.IncrementalKindCode = this.currentVoucherKind?.IncrementalKindCode;
              this.model.SendToInvDailyVoucher = this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.SendToInvDailyVoucher;
              this.setValue("IncrementalKindCode", this.model?.IncrementalKindCode);
              if (data.HasOpositeParty) this.selectorService.setDataStateChange("DetailLedgerId", this.onDataStateChange);

              if (this._id && this.model?.VoucherNo) {
                this.label = data.Title + `(${this.model?.VoucherNo})`;
                this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
              }
              this.setValue("VoucherKindCode", this.currentVoucherKind?.Code);
              if (this.ShowStockAmount) this.setStockInfoColumns();
              if (this.hasReference) this.setReferenceVoucherColumns();
              this.setMaxCode();
              this.setColumnAttribute();
              this.addControl();
            }
          } catch (e) {
            console.log(e);
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
  isNoValidForEdit(): boolean {
    let StatusKindCode: number = InvStatusKind.Confirmed;
    let EditStatusKindCode: number = InvStatusKind.AccountRegistered;
    this.isNonValidEdit = this.model?.StatusKindCode == EditStatusKindCode;
    return (!this.isNewRow && this.model && this.model?.StatusKindCode >= StatusKindCode) || this.model?.HasReferencedVoucherTo;
  }
  setColumnAttribute() {
    try {
      this.setlocalColumns();
      this.orignalColumns?.forEach((x) => {
        if (x.name === "WarehouseTransferId") {
          if (this.currentVoucherKind && this.currentVoucherKind?.HasWarehouseTransfer) {
            x.formVisible = this.currentVoucherKind?.HasWarehouseTransfer;
            x.disabled = !this.currentVoucherKind?.HasWarehouseTransfer;
            if (this.currentVoucherKind?.HasWarehouseTransfer) x.required = this.currentVoucherKind?.HasWarehouseTransfer;
            if (this.currentVoucherKind?.OpositePartyWarehouseCaption) x.label = this.currentVoucherKind?.OpositePartyWarehouseCaption;
            if (x.required === true) {
              this.formGroup.controls[x.name].clearValidators();
              this.formGroup.controls[x.name].setValidators(Validators.required);
            }
          } else {
            x.formVisible = this.currentVoucherKind?.HasWarehouseTransfer;
            x.disabled = true;
            x.required = false;
          }
        }

        if (x.name === "DestinationBranchId") {
          x.formVisible = this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.SendToInvDailyVoucher;
          x.required = this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.SendToInvDailyVoucher;
          if (x.required === true) {
            this.formGroup.controls[x.name].clearValidators();
            this.formGroup.controls[x.name].setValidators(Validators.required);
          }
        }
        if (x.name === "VoucherDate") {
          if (this.currentVoucherKind) {
            x.disabled = this.currentVoucherKind?.HasCheckVoucherDate;
            if (this.formGroup && this.formGroup?.get(x.name)) {
              if (x.disabled) this.formGroup?.get(x.name).disable();
              else this.formGroup?.get(x.name).enable();
              this.formGroup?.get(x.name).updateValueAndValidity();
            }
          }
        }
        if (x.name === "WarehouseId") {
          if (this.currentVoucherKind) {
            if (this.currentVoucherKind?.Code >= 1001 && this.currentVoucherKind?.Code <= 1005) {
              const branch = this.accountService.authService.currentBranch;
              this.model.WarehouseId = branch.InvWarehouseId;
              this.setValue("WarehouseId", branch.InvWarehouseId);
            }
            x.formVisible = this.currentVoucherKind?.ShowWarehouse;
            x.disabled =
              !this.currentVoucherKind?.ShowWarehouse ||
              this.currentVoucherKind?.NoChangeRefereWarehouseDetailLedger === true ||
              (this.currentVoucherKind.Code >= 1001 && this.currentVoucherKind.Code <= 1005);
            x.required = this.currentVoucherKind?.ShowWarehouse || this.currentVoucherKind?.IncrementalKindCode <= IncrementalKind.Decrement;
            if (this.currentVoucherKind?.WarehouseCaption) x.label = this.currentVoucherKind?.WarehouseCaption;
            if (x.required === true) {
              this.formGroup.controls[x.name].clearValidators();
              this.formGroup.controls[x.name].setValidators(Validators.required);
            }
          } else {
            x.formVisible = this.currentVoucherKind?.ShowWarehouse ?? false;
            x.disabled = true;
            x.required = false;
          }
        }
        if (x.name === "SubLedgerId") {
          if (this.currentVoucherKind) {
            x.formVisible = this.currentVoucherKind?.HasSubledger;
            x.disabled = !this.currentVoucherKind?.HasSubledger;
          } else {
            x.formVisible = this.currentVoucherKind?.HasSubledger ?? false;
            x.disabled = true;
          }
        }
        if (x.name === "DetailLedgerId") {
          if (this.currentVoucherKind) {
            x.formVisible = this.currentVoucherKind?.HasOpositeParty;
            x.disabled = !this.currentVoucherKind?.HasOpositeParty || this.currentVoucherKind?.NoChangeRefereWarehouseDetailLedger === true;
            if (this.currentVoucherKind?.HasOpositeParty) x.label = this.currentVoucherKind?.OpositePartyCaption;
            if (this.currentVoucherKind?.HasOpositeParty) x.order = 1;
            x.required = !this.currentVoucherKind?.HasOpositeParty;
            if (x.required === true) {
              this.formGroup.controls[x.name].clearValidators();
              this.formGroup.controls[x.name].setValidators(Validators.required);
            }
          } else {
            x.formVisible = this.currentVoucherKind?.HasOpositeParty ?? false;
            x.disabled = true;
            x.required = false;
          }
        }
        if (x.name === "ReceiptDate" || x.name === "ReceiptDays") {
          if (this.currentVoucherKind) {
            x.formVisible = this.currentVoucherKind?.HasReceiptDate;
            x.disabled = !this.currentVoucherKind?.HasReceiptDate;
          } else {
            x.formVisible = this.currentVoucherKind?.HasReceiptDate ?? false;
            x.disabled = true;
          }
        }
        if (x.name === "Invoicecredit") {
          if (this.currentVoucherKind) {
            x.formVisible = this.currentVoucherKind?.HasCredit;
            x.disabled = !this.currentVoucherKind?.HasCredit;
          } else {
            x.formVisible = this.currentVoucherKind?.HasReceiptDate ?? false;
            x.disabled = true;
          }
        }
        if (x.name === "TransportInterfaceSubLedgerId" || x.name === "TransportInterfaceDetailLedgerId") {
          if (this.currentVoucherKind) {
            x.formVisible = this.currentVoucherKind?.HasTransportInterface;
            x.disabled = !this.currentVoucherKind?.HasTransportInterface;
          } else {
            x.formVisible = this.currentVoucherKind?.HasTransportInterface ?? false;
            x.disabled = true;
            x.required = false;
          }
        }

        if (x.name === "ReferenceVoucherKindId") {
          if (this.hasReference) {
            x.formVisible = this.hasReference;
            x.disabled = !this.hasReference;
            if (this.hasReference) x.required = this.hasReferenceRequired;
            if (x.required === true) {
              this.formGroup.controls[x.name].clearValidators();
              this.formGroup.controls[x.name].setValidators(Validators.required);
            }
            if (this.hasReference) {
              this.setReferenceVoucherKind();
              this.setReferenceToVoucherKind();
              if (!this.model.ReferenceVoucherKindId) {
                let vk = this.currentVoucherKind?.ReferenceVoucherKinds.find((vk) => vk.IsDefault);
                if (vk) {
                  this.model.ReferenceVoucherKindId = vk.ReferenceVoucherKindId;
                  this.setValue("ReferenceVoucherKindId", vk.ReferenceVoucherKindId);
                }
              }
            }
          } else {
            x.formVisible = this.hasReference;
            x.disabled = true;
            x.required = false;
          }
        }
        if (x.name === "SlaveNo") {
          if (this.currentVoucherKind) {
            x.formVisible = this.currentVoucherKind?.HasSlaveNo;
            x.disabled = !this.currentVoucherKind?.HasSlaveNo;
            if (this.currentVoucherKind?.SlaveNoCaption) x.label = this.currentVoucherKind?.SlaveNoCaption;
          } else {
            x.formVisible = this.currentVoucherKind?.HasSlaveNo ?? false;
            x.disabled = true;
          }
        }
      });
      if (this.formGroup?.controls["StatusKindCode"].value === InvStatusKind.Registered && !this.isNoValidForEdit()) {
        this.voucherConfirmDisable = true;
        this.cd.markForCheck();
      }
      if (this.isNoValidForEdit()) {
        this.orignalColumns?.forEach((x) => {
          if (
            (!x.name.includes("DetailLedger2") &&
              !x.name.includes("DetailLedger3") &&
              !x.name.includes("SubLedger") &&
              !x.name.includes("DetailLedger4") &&
              !x.name.includes("DetailLedger5")) ||
            this.model.StatusKindCode === InvStatusKind.AccountRegistered
          )
            x.disabled = true;
          else x.disabled = false;
          if (this.formGroup && this.formGroup?.get(x.name)) {
            if (x.disabled) this.formGroup?.get(x.name).disable();
            else this.formGroup?.get(x.name).enable();
            this.formGroup?.get(x.name).updateValueAndValidity();
          }
        });
      } else {
        this.orignalColumns?.forEach((x) => {
          if (this.formGroup && this.formGroup?.get(x.name)) {
            if (x.disabled) this.formGroup?.get(x.name).disable();
            else this.formGroup?.get(x.name).enable();
            this.formGroup?.get(x.name).updateValueAndValidity();
          }
        });
      }
      if (this.formGroup) this.formGroup?.updateValueAndValidity();
      if (this.currentVoucherKind) {
        this.label = this.currentVoucherKind?.Title + `(${this.model.VoucherNo})`;
        if (this._id) this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
      }
      if (this.formGroup) this.formGroup?.updateValueAndValidity();
      this.cd.markForCheck();
      this.InvVoucherDetailColumns = this.getDetailControlModels("InvVoucherDetailList");
      if (this.model?.StatusKindCode == InvStatusKind.AccountRegistered) {
        this.InvVoucherDetailColumns.forEach((element) => {
          element.disabled = true;
        });
      } else {
        if (this.model?.StatusKindCode >= InvStatusKind.Confirmed || this.model?.StatusKindCode >= InvStatusKind.Calculated) {
          this.InvVoucherDetailColumns.forEach((element) => {
            if (element.name != "DetailLedgerId" && element.name != "DetailLedger2Id" && element.name != "DetailLedger3Id") element.disabled = true;
          });
        }
      }
      this.columns = this.orignalColumns?.filter(
        (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
      );
      this.columns = this.columns.sort((a, b) => a.order - b.order);
      this.cd.markForCheck();
    } catch (e) {
      console.log(e);
    }
    this.columns.forEach((x) => {
      x.isFloat = null;
      x.userClass = null;
      x.columnNumber = null;
      if (x.name === "Comment") x.userClass = "inv-desc";
    });
    this.cd.markForCheck();
  }
  setReferenceVoucherKind() {
    if (this.isLoadingReferenceVoucherKind === true) return;
    this.isLoadingReferenceVoucherKind = true;
    this.httpCommonService
      .get("InvVoucherKind/ReadLookUp")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.isLoadingReferenceVoucherKind = false;
          let vk = (data as InvVoucherKind[]).filter((x) =>
            this.currentVoucherKind?.ReferenceVoucherKinds.some((vk) => vk.ReferenceVoucherKindId === x.Id)
          );
          this.selectorService.setDataList("ReferenceVoucherKindId", vk);
        },
        (error) => {
          this.isLoadingReferenceVoucherKind = false;
          this.getFailedHelper(error);
        }
      );
  }
  async changeReferenceToVoucherKind(id: number) {
    let vk = this.ReferenceToVoucherKinds.find((x) => x.Id === id);
    if (!vk) return;
    let rvk: ReferenceVoucherKind = <ReferenceVoucherKind>{ InvVoucherKindId: vk.Id };
    if (!this.model.HasReferencedVoucherTo && vk) await this.CreateVoucherKindReferencedTo(rvk);
    else this.erroremessage = "برای این سند قبلا معطوف صادر شده است.";
  }
  async setReferenceToVoucherKind() {
    await this.httpCommonService
      .get("InvVoucherKind/GetReferenceVoucherKind/?id=" + this.currentVoucherKind?.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: InvVoucherKind[]) => {
          if (data && data.length > 0) {
            this.ReferenceToVoucherKinds = data;
            this.CurrentReferenceToVoucherKindId = data[0].Id;
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }

  setDefaultValues() {
    this.orignalColumns?.forEach((x) => {
      if (x.controlType === FormControlTypes.checkbox && this.model[x.name] === undefined) this.model[x.name] = false;
      if (x.name === "VoucherDate") x.disabled = this.currentVoucherKind && this.currentVoucherKind?.HasCheckVoucherDate;
    });
  }
  addControl() {
    this.selectorService.setIsFloat("TotalDiscount", true);
    this.isOkForLoad = false;
    if (this.formGroup) this.setSummery();
    if (this.currentVoucherKind?.HasSubledger && this.currentVoucherKind?.DefaultSubLedgerId && !this.model?.SubLedgerId)
      this.setValue("SubLedgerId", this.currentVoucherKind?.DefaultSubLedgerId);
    if (this.currentVoucherKind?.ShowWarehouse && this.currentVoucherKind?.DefaultWarehouseId && !this.model?.WarehouseId)
      this.setValue("WarehouseId", this.currentVoucherKind?.DefaultWarehouseId);
    if (this.currentVoucherKind !== undefined) this.isOkForLoad = true;
    if (this.formGroup?.controls["VoucherDate"])
      this.formGroup?.controls["VoucherDate"].valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => this.isValid());
    this.hasPriceRefresh =
      this.currentVoucherKind &&
      this.currentVoucherKind?.HasPriceRefresh &&
      (this.isNewRow || this.model.StatusKindCode == InvStatusKind.Registered) &&
      !this.missetup.getboolean("INV", "CostBasedPricing");
    this.isFristReplaceGoodsSimilar =
      this.isNewRow && this.currentVoucherKind && this.currentVoucherKind?.IncrementalKindCode === IncrementalKind.Decrement;
    this.cd.markForCheck();
    this.formGroup?.controls["TransportInterfaceSharingKindCode"].valueChanges.subscribe((x) => {
      this.SetTransportPrice();
    });
  }
  onChanged($event) {
    if (this.isNewRow) this.setdefault();
    if ($event && $event.apiName === "LookUp" && $event.data.SystemName === "INV" && $event.data.Category === "TransportInterfaceSharingKind") {
      this.model.TransportInterfaceSharingKindCode = $event.data.Code;
      this.model.TransportInterfaceSharingKindLatinTitle = $event.data.Title;
      this.setValue("TransportInterfaceSharingKindCode", $event.data.Code);
      this.setValue("TransportInterfaceSharingKindLatinTitle", $event.data.Title);
      this.SetTransportPrice();
    }
  }
  onValueChanges($event) {
    if (this.detail && this.detail?.dataList) this.model.InvVoucherDetailList = this.detail?.dataList;
    if (!this.isloading && $event && ($event.UnitId || $event.GoodsId) && $event.State !== RowState.Delete && $event.State !== RowState.Detached) {
      this.isloading = true;
      let goodsId: number = $event.GoodsId ? $event.GoodsId : $event.Id;
      var filters: GridFilter[] = [];
      let isReadable: boolean = false;
      if (this.stockList && this.stockList.length > 0) this.filterdDataList = this.stockList.filter((f) => f.GoodsId === goodsId);
      filters.push({ Filed: "FiscalYearId", Operator: "eq", Type: "F", Skip: 0, Take: 1000, Value: this.model.FiscalYearId, Logic: "and" });
      let voucherdate: Date = this.formGroup?.get("VoucherDate")?.value;
      if (isNullOrUndefined(voucherdate)) {
        if (!this.model.VoucherDate) voucherdate = new Date();
        else voucherdate = this.model.VoucherDate;
      }
      filters.push({ Filed: "VoucherDate", Operator: "lte", Type: "F", Skip: 0, Take: 1000, Value: voucherdate, Logic: "and" });
      var GoodsIds: number[] = [];
      this.model?.InvVoucherDetailList?.forEach((x) => {
        if (x.GoodsId && !GoodsIds.some((g) => g === x.GoodsId)) {
          GoodsIds.push(x.GoodsId);
          isReadable = true;
        }
      });
      if (goodsId && !GoodsIds.some((g) => g === goodsId)) {
        GoodsIds.push(goodsId);
        isReadable = true;
      }
      if (!isReadable) {
        this.filterdDataList = this.stockList?.filter((f) => f.GoodsId === goodsId);
        return;
      }
      filters.push({ Filed: "GoodsIds", Operator: "eq", Type: "F", Skip: 0, Take: 1000, Value: GoodsIds, Logic: "and" });
      this.setSummery();
      this.httpCommonService
        .create(`InvVoucherHeader/GetCaredx`, filters)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x: PagingDataResult<StockInfo>) => {
            this.isloading = false;
            this.stockList = x.Data as [];
            this.stockListLoaded.next(true);
            this.filterdDataList = this.stockList.filter((f) => f.GoodsId === goodsId);
            if ($event && $event.GoodsId) {
              if ($event.State === RowState.Delete || $event.State === RowState.Detached) {
                this.erroremessage = undefined;
                this.model?.InvVoucherDetailList?.forEach((x) => {
                  this.setGoodsValidation(x);
                });
              } else this.setGoodsValidation($event);
            }
            this.cd.markForCheck();
          },
          (error) => {
            this.isloading = false;
            this.getFailedHelper(error);
          }
        );
    }

    if ($event && $event.GoodsId) {
      if ($event.State === RowState.Delete || $event.State === RowState.Detached) {
        this.erroremessage = undefined;
        if (this.formGroup?.get("WarehouseId")?.value)
          this.model?.InvVoucherDetailList?.forEach((x) => {
            this.setGoodsValidation(x);
          });
      } else {
        if (this.formGroup?.get("WarehouseId")?.value)
          this.model?.InvVoucherDetailList?.forEach((x) => {
            this.setGoodsValidation(x);
          });
      }
    }
    if (!this.isValidating) this.isValid();
    if (this.model.InvVoucherDetailList.some((x) => x.State === RowState.Modify) && this.isNoValidForEdit() === true) this.formGroup?.markAsTouched();
  }
  getStockList() {
    var filters: GridFilter[] = [];
    filters.push({ Filed: "FiscalYearId", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: this.model.FiscalYearId, Logic: "and" });
    let voucherdate: Date = this.formGroup?.get("VoucherDate")?.value;
    if (isNullOrUndefined(voucherdate)) {
      if (!this.model.VoucherDate) voucherdate = new Date();
      else voucherdate = this.model.VoucherDate;
    }
    filters.push({ Filed: "VoucherDate", Operator: "lte", Type: "F", Skip: 0, Take: 20, Value: voucherdate, Logic: "and" });
    filters.push({
      Filed: "WarehouseId",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.formGroup?.controls["WarehouseId"].value,
      Logic: "and",
    });
    return this.httpCommonService.create(`InvVoucherHeader/GetCaredx`, filters);
  }
  onValueChangeByApiName($event) {
    if ($event && $event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Warehouse")) {
      this.model.WarehouseTitle = $event.data.Title;
      this.model.WarehouseCode = $event.data.Code;
      this.setMaxCode();
    }
    if (this.model.InvVoucherDetailList !== undefined && this.model?.InvVoucherDetailList?.length > 0) {
      this.erroremessage = undefined;
      this.model?.InvVoucherDetailList?.filter(
        (x) => x.State !== RowState.Delete && x.State !== RowState.Detached && x.State !== RowState.SoftDelete
      ).forEach((x) => {
        this.onValueChanges(x);
      });
    }
    if (!this.isValidating) this.isValid();
    else if ($event && $event.apiName && $event.data && $event.data.Id && $event.apiName.includes("DetailLedger")) {
      this.isValid();
    }
    this.isValidating = false;
  }
  setGoodsValidation(event: InvVoucherDetail) {
    this.goodsError = false;
    this.erroremessage = undefined;
    if (event.ReferenceId && event.ReferenceId > 0 && event.BaseAmount > 0) {
      if (event.Amount > event.BaseAmount && !this.currentVoucherKind?.BasedOnBOM) {
        this.goodsError = true;
        this.erroremessage = `برای کالای ${event.GoodsTitle} با کد(${event.GoodsCode})  در انبار ${this.model.WarehouseTitle} مقدار نمی تواند از مقدارمبنا بیشتر باشد.`;
      }
    }
    if (this.formGroup?.get("WarehouseId")?.value) {
      if (this.currentVoucherKind && this.currentVoucherKind?.IncrementalKindCode === IncrementalKind.Decrement && event.MainAmount) {
        let stockinfo = this.stockList.find((x) => x.WarehouseId === this.formGroup?.get("WarehouseId")?.value && x.GoodsId === event.GoodsId);
        if (
          this.currentVoucherKind?.IncrementalKindCode === IncrementalKind.Decrement &&
          event.State != RowState.Delete &&
          (!stockinfo || stockinfo.StockAmount + event.OrignalMainAmount - event.MainAmount < 0)
        )
          if (!this.missetup.getboolean("INV", "NegativeBalance")) {
            this.goodsError = true;
            event.HasError = true;
            this.erroremessage = `برای کالای ${event.GoodsTitle} با کد(${event.GoodsCode})  در انبار ${this.model.WarehouseTitle} موجودی کافی وجود ندارد.`;
          }
      }
    }
    this.cd.markForCheck();
  }
  setSummery() {
    if (this.model === undefined || this.model.InvVoucherDetailList === undefined) return;
    if (!this.formGroup?.controls["TotalPrice"])
      this.formGroup?.addControl("TotalPrice", new UntypedFormControl(this.model?.InvVoucherDetailList?.getSumWithKey("Price")));
    else this.formGroup?.controls["TotalPrice"].setValue(this.model?.InvVoucherDetailList?.getSumWithKey("Price"));

    if (!this.formGroup?.controls["SumPrice"])
      this.formGroup?.addControl("SumPrice", new UntypedFormControl(this.model?.InvVoucherDetailList?.getSumWithKey("TotalPrice")));
    else this.formGroup?.controls["SumPrice"].setValue(this.model?.InvVoucherDetailList?.getSumWithKey("TotalPrice"));

    if (this.hasDiscount) {
      if (!this.formGroup?.controls["DiscountAmount"])
        this.formGroup?.addControl("DiscountAmount", new UntypedFormControl(this.model?.InvVoucherDetailList?.getSumWithKey("DiscountAmount")));
      else {
        var test = this.model?.InvVoucherDetailList?.getSumWithKey("DiscountAmount");
        this.formGroup?.controls["DiscountAmount"].setValue(this.model?.InvVoucherDetailList?.getSumWithKey("DiscountAmount"));
      }
      if (!this.formGroup?.controls["SumDeduction"])
        this.formGroup?.addControl("SumDeduction", new UntypedFormControl(this.model?.InvVoucherDetailList?.getSumWithKey("Deduction")));
      else this.formGroup?.controls["SumDeduction"].setValue(this.model?.InvVoucherDetailList?.getSumWithKey("Deduction"));
    }
    if (this.hasTaxDuty) {
      if (!this.formGroup?.controls["Tax"])
        this.formGroup?.addControl("Tax", new UntypedFormControl(this.model?.InvVoucherDetailList?.getSumWithKey("Tax")));
      else this.formGroup?.controls["Tax"].setValue(this.model?.InvVoucherDetailList?.getSumWithKey("Tax"));
    }
    if (!this.formGroup?.controls["SumSurplusage"])
      this.formGroup?.addControl("SumSurplusage", new UntypedFormControl(this.model?.InvVoucherDetailList?.getSumWithKey("Surplusage")));
    else this.formGroup?.controls["SumSurplusage"].setValue(this.model?.InvVoucherDetailList?.getSumWithKey("Surplusage"));
    if (!this.formGroup?.controls["PaymentValue"]) this.formGroup?.addControl("PaymentValue", new UntypedFormControl(0));
    else this.formGroup?.controls["PaymentValue"].setValue(0);
    if (!this.formGroup?.controls["RemainValue"]) this.formGroup?.addControl("RemainValue", new UntypedFormControl(0));
    else this.formGroup?.controls["RemainValue"].setValue(0);
  }
  isValueValid() {
    if (this.formGroup?.controls["TransportPrice"].value && this.formGroup?.controls["TransportPrice"].value < 0) {
      this.erroremessage = `کرایه نمی تواند منفی باشد.`;
    }
    if (this.formGroup?.controls["TransportTax"].value && this.formGroup?.controls["TransportTax"].value < 0) {
      this.erroremessage = `مالیات کرایه نمی تواند منفی باشد.`;
    }
  }
  isChanged = () => {
    let flag: boolean = false;
    Object.keys(this.model).forEach((key) => {
      if (!key.includes("SubLedger") && !key.includes("DetailLedger") && this.formGroup?.get(key)?.value)
        flag = this.formGroup?.get(key)?.value !== this.model[key];
    });
    return flag;
  };
  isValid() {
    let flag: boolean = true;
    if (this.isValidating) return;
    if (!this.formGroup?.valid && !this.formGroup?.get("StatusKindId")?.value) this.setStatusKind();
    if (!this.goodsError) this.erroremessage = undefined;
    else flag = false;
    if (this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.IsTakingOfInventory && !this.isChanged) {
      this.erroremessage = "شما مجاز به ویرایش / حذف سند انبارگردنی نیستید.";
      return false;
    }
    this.isValueValid();
    flag = !this.erroremessage ? true : false;
    if (
      new Date(this.formGroup?.controls["VoucherDate"].value).setHours(0, 0, 0, 0) <
        new Date(this.accountService.authService.currentFiscalYear.StartDate).setHours(0, 0, 0, 0) ||
      new Date(this.formGroup?.controls["VoucherDate"].value).setHours(0, 0, 0, 0) >
        new Date(this.accountService.authService.currentFiscalYear.EndDate).setHours(0, 0, 0, 0)
    ) {
      this.erroremessage = "تاریخ سند باید در محدوده سال مالی باشد.";
      return false;
    }
    // if (flag && this.currentVoucherKind && this.currentVoucherKind.FormOperationKindCode === FormOperationKind.SendToInvDailyVoucher && !this.isNewRow) {
    //   this.erroremessage = "سند از نوع ارسال به انبار روزانه قابل ویرایش نیست.";
    //   flag = false;
    // }

    if (flag && this.currentVoucherKind && this.currentVoucherKind?.HasCheckVoucherDate && this.isNewRow) {
      if (new Date(this.formGroup?.controls["VoucherDate"].value).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
        this.erroremessage = "تاریخ سند نمی تواند کوچکتر از تاریخ جاری باشد.";
        flag = false;
      }
    }

    if (!this.formGroup?.controls["FiscalYearId"].value && !this.accountService.authService.currentFiscalYear) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) this.setValue("FiscalYearId", x.Id);
      });
    }
    if (this.currentVoucherKind?.HasOpositeParty && flag) {
      if (!this.formGroup?.controls["DetailLedgerId"]?.value) {
        this.erroremessage = `انتخاب  ${this.getColumnCaption("DetailLedgerId")} الزامی است.`;
        flag = false;
      }
    }
    if (this.erroremessage && flag) flag = false;
    if (flag) {
      if (
        this.currentVoucherKind &&
        (this.currentVoucherKind?.IncrementalKindCode <= IncrementalKind.Decrement ||
          this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseInvoice ||
          this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.IsReturnPurchaseInvoice) &&
        !this.formGroup?.get("WarehouseId")?.value &&
        !this.model.WarehouseId
      ) {
        this.erroremessage = "برای اسناد با ماهیت افزاینده/کاهنده/فاکتور خرید انتخاب انبار الزامی است.";

        flag = false;
      }
      if (flag) {
        if (
          this.model.InvVoucherDetailList &&
          this.model?.InvVoucherDetailList?.filter((x) => x.Id != -1 && x.State !== RowState.Delete && x.State !== RowState.Detached).length > 0
        ) {
          flag = this.formGroup?.valid || this.formGroup?.status === "DISABLED";
        } else {
          this.erroremessage = "برای سند هیچ قلمی وارد نشده است.";
          flag = false;
        }
      }
      if (
        flag &&
        this.currentVoucherKind?.HasWarehouseTransfer &&
        this.formGroup?.controls["WarehouseId"].value === this.formGroup?.controls["WarehouseTransferId"].value
      ) {
        flag = false;
        this.erroremessage = "انبار مبداء و مقصد نمی تواند یکی باشد.";
      }
      if (
        (flag && this.currentVoucherKind?.AutoFocusedDocumentIssuance && this.currentVoucherKind?.AutoCreateVoucherKindId !== undefined) ||
        this.currentVoucherKind?.HasAutoConfirm
      ) {
        if (
          this.currentVoucherKind &&
          this.currentVoucherKind?.HasWarehouseTransfer &&
          this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseInvoice &&
          this.currentVoucherKind?.IncrementalKindCode === 1 &&
          this.model?.InvVoucherDetailList?.some(
            (x) => x.Id != -1 && x.State !== RowState.Detached && x.State !== RowState.Delete && x.UnitPrice === 0
          )
        ) {
          this.erroremessage = "بعلت اقلام بدون قیمت سند قابل تائید نیست.";
          flag = false;
        }
      }
      if (flag) {
        if (
          this.model?.InvVoucherDetailList?.some(
            (x) => x.Id != -1 && x.State !== RowState.Detached && x.State !== RowState.Delete && (!x.Amount || x.Amount <= 0)
          )
        ) {
          this.erroremessage = "مقدار نمی تواند خالی باشد.";
          flag = false;
        }
      }
      if (
        flag &&
        this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseInvoice &&
        this.model?.InvVoucherDetailList &&
        this.model?.InvVoucherDetailList?.some(
          (x) =>
            x.Id != -1 &&
            (!x.UnitPrice || x.UnitPrice <= 0) &&
            x.State !== RowState.Delete &&
            x.State !== RowState.Detached &&
            x.State !== RowState.SoftDelete
        )
      ) {
        this.erroremessage = "تکمیل فی اقلام الزامی است.";
        flag = false;
      }
      if (flag && this.currentVoucherKind?.IncrementalKindCode === IncrementalKind.Decrement) {
        this.model?.InvVoucherDetailList?.forEach((x) => {
          if (flag) {
            this.isValidating = true;
            this.onValueChanges(x);
            this.isValidating = false;
            if (this.stockList?.length <= 0 && this.erroremessage) {
              this.isValidating = true;
              this.onValueChanges(x);
              this.isValidating = false;
            }
            flag = !this.erroremessage;
          }
        });
      }
      if (flag) {
        this.isValidating = true;
        this.onValueChangeByApiName(null);
        this.isValidating = false;
        flag = !this.erroremessage;
      }
    }

    return flag;
  }
  getFilters(columnsName: string, searchValue: string, skip: number, take: number) {
    var filters: GridFilter[] = [];
    const columns = columnsName.split(",");
    columns.forEach((x) => {
      {
        if (x !== "Id")
          filters.push({ Filed: x, Operator: "contains", Type: "F", Skip: skip, Take: take, Value: searchValue.toString(), Logic: "or" });
        else if (isNumber(searchValue))
          filters.push({ Filed: x, Operator: "eq", Type: "F", Skip: skip, Take: take, Value: Number(searchValue), Logic: "or" });
      }
    });
    return filters;
  }
  onDataStateChange(columnName: string, searchValue: string, skip: number, take: number): Observable<PagingDataResult<DetailLedger>> {
    var abs = new BehaviorSubject<PagingDataResult<DetailLedger>>(null);
    const dLkids: number[] = [];
    if (
      columnName === "DetailLedgerId" &&
      this.currentVoucherKind?.VoucherKindDetailLedgerKinds &&
      this.currentVoucherKind?.VoucherKindDetailLedgerKinds.length > 0
    ) {
      this.currentVoucherKind?.VoucherKindDetailLedgerKinds.forEach((x) => dLkids.push(x.DetailLedgerKindId));
    }
    let apiName: string = "DetailLedger/DetailLedgerWithDetailLedgerKindIds";
    const filter = this.getFilters("Id,Code,Title", searchValue, skip, take);
    if (dLkids && dLkids.length > 0)
      filter.push({ Filed: "dLkinds", Operator: "eq", Value: dLkids, Type: "F", Skip: skip, Take: take, Logic: "and" });
    this.httpCommonService
      .GetFilterGrid<PagingDataResult<DetailLedger>>(apiName, filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x: PagingDataResult<DetailLedger>) => {
        if (x) abs.next(x);
      });
    return abs.asObservable();
  }
  preSave() {
    if (this.model.StatusKindCode !== InvStatusKind.Registered) return;
    var filters: GridFilter[] = [];
    filters.push({ Filed: "FiscalYearId", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: this.model.FiscalYearId, Logic: "and" });
    let voucherdate: Date = this.formGroup?.get("VoucherDate")?.value;
    if (isNullOrUndefined(voucherdate)) {
      if (!this.model.VoucherDate) voucherdate = new Date();
      else voucherdate = this.model.VoucherDate;
    }
    filters.push({ Filed: "VoucherDate", Operator: "lte", Type: "F", Skip: 0, Take: 20, Value: voucherdate, Logic: "and" });
    var GoodsIds: number[] = [];
    this.model?.InvVoucherDetailList?.forEach((x) => {
      if (x.GoodsId && !GoodsIds.some((g) => g === x.GoodsId)) {
        GoodsIds.push(x.GoodsId);
      }
    });
    filters.push({ Filed: "GoodsIds", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: GoodsIds, Logic: "and" });
    this.httpCommonService
      .create(`InvVoucherHeader/GetCaredx`, filters)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x: PagingDataResult<StockInfo>) => {
          this.isloading = false;
          this.stockList = x.Data as [];
          this.stockListLoaded.next(true);
        },
        (error) => {
          this.isloading = false;
          this.getFailedHelper(error);
        }
      );
    let errors: string = "";
    this.model?.InvVoucherDetailList?.filter(
      (x) => x.Id != -1 && x.State !== RowState.Delete && x.State !== RowState.Detached && x.State !== RowState.SoftDelete
    )?.forEach((x) => {
      this.setGoodsValidation(x);
      if (this.erroremessage) errors = errors + "," + this.erroremessage;
    });
    if (errors) {
      this.goodsError = true;
      this.erroremessage = errors;
    }
  }
  beforupdate() {
    if (this.detail) {
      if (this.detail.formGroup && this.detail?.formGroup?.valid) this.detail.saveCurrent();
      else this.detail.cancelHandler();
    }
    if (this.model.AccVoucherFixNumber > 0) return;

    this.setValue("SendToInvDailyVoucher", this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.SendToInvDailyVoucher);

    if (!this.formGroup?.controls["BasedOnBOM"]) this.setValue("BasedOnBOM", this.currentVoucherKind?.BasedOnBOM);

    if (this.model.InvVoucherDetailList !== undefined && this.model?.InvVoucherDetailList?.length > 0) {
      this.erroremessage = undefined;
      this.model?.InvVoucherDetailList?.filter(
        (x) => x.Id != -1 && x.State !== RowState.Delete && x.State !== RowState.Detached && x.State !== RowState.SoftDelete
      ).forEach((x) => {
        this.onValueChanges(x);
      });
    }

    this.model.InvVoucherDetailList = this.model?.InvVoucherDetailList?.filter((x) => x.State !== RowState.Detached);
    if (
      (this.currentVoucherKind?.HasAutoConfirm ||
        this.currentVoucherKind?.HasJournalVoucherAuto ||
        this.currentVoucherKind?.AutoFocusedDocumentIssuance) &&
      this.model.StatusKindCode < InvStatusKind.Confirmed
    ) {
      this.lookupservice
        .getLookupbyCode("INV", "StatusKind", InvStatusKind.Confirmed)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            this.model.StatusKindId = x.Id;
            this.model.StatusKindCode = x.Code;
            this.model.StatusKindTitle = x.Title;
            this.setValue("StatusKindId", x.Id);
            this.setValue("StatusKindCode", x.Code);
            this.setValue("StatusKindTitle", x.Title);

            if (this.model.StatusKindCode === InvStatusKind.Confirmed) this.confirmLabel = "برگشت از تایید";
            else this.confirmLabel = "تایید سند";
          }
        });
    }

    if (this.model.InvVoucherDetailList && this.model?.InvVoucherDetailList?.length > 0) {
      if (!this.formGroup?.controls["InvVoucherDetailList"])
        this.formGroup?.addControl("InvVoucherDetailList", new UntypedFormControl(this.model.InvVoucherDetailList));
      else this.formGroup?.controls["InvVoucherDetailList"].setValue(this.model.InvVoucherDetailList);
    } else this.erroremessage = "برای سند هیچ قلمی وارد نشده است.";

    if (
      (this.currentVoucherKind?.AutoFocusedDocumentIssuance && this.currentVoucherKind?.AutoCreateVoucherKindId !== undefined) ||
      this.currentVoucherKind?.HasAutoConfirm
    ) {
      if (this.model.StatusKindCode <= InvStatusKind.Registered) this.setConfirmStatusKind();
    }
    this.SetTransportPrice();
  }
  SetTransportPrice() {
    if (this.model.StatusKindCode >= InvStatusKind.Confirmed) return;
    if (
      this.currentVoucherKind?.HasTransportInterface &&
      this.model !== null &&
      this.model.InvVoucherDetailList !== null &&
      this.model?.InvVoucherDetailList?.some((x) => x.Id != -1 && x.State !== RowState.Delete && x.State !== RowState.Detached) &&
      this.formGroup?.controls["TransportPrice"] &&
      this.formGroup?.controls["TransportPrice"].value > 0
    ) {
      switch (this.formGroup?.controls["TransportInterfaceSharingKindCode"].value ?? this.model.TransportInterfaceSharingKindCode) {
        case 1:
          let TotalAmount: number = this.model?.InvVoucherDetailList?.getSumWithKey("MainAmount");
          this.model?.InvVoucherDetailList?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).forEach((x) => {
            x.TransportPrice = Math.round((this.formGroup?.controls["TransportPrice"].value * x.MainAmount) / TotalAmount);
            if (this.formGroup?.controls["TransportTax"].value > 0)
              x.TransportTax = Math.round((this.formGroup?.controls["TransportTax"].value * x.MainAmount) / TotalAmount);
            else x.TransportTax = 0;

            if (x.State === RowState.NoChange && this.model.StatusKindCode < InvStatusKind.Confirmed) x.State = RowState.Modify;
          });
          break;

        case 2:
          let TotalPrice: number = this.model?.InvVoucherDetailList?.getSumWithKey("Price");
          this.model?.InvVoucherDetailList?.filter((x) => x.Id != -1 && x.State !== RowState.Delete && x.State !== RowState.Detached).forEach((x) => {
            x.TransportPrice = Math.round((this.formGroup?.controls["TransportPrice"].value * x.Price) / TotalPrice);
            if (this.formGroup?.controls["TransportTax"].value > 0)
              x.TransportTax = Math.round((this.formGroup?.controls["TransportTax"].value * x.Price) / TotalPrice);
            else x.TransportTax = 0;

            if (x.State === RowState.NoChange) x.State = RowState.Modify;
          });
          break;

        case 3:
          let EqualPrice =
            this.formGroup?.controls["TransportPrice"].value /
            this.model?.InvVoucherDetailList?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).length;
          this.model?.InvVoucherDetailList?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).forEach((x) => {
            x.TransportPrice = Math.round(EqualPrice);
            x.TransportTax = Math.round(
              this.formGroup?.controls["TransportTax"].value /
                this.model?.InvVoucherDetailList?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).length
            );
            if (x.State === RowState.NoChange) x.State = RowState.Modify;
          });
          break;

        default:
          this.model?.InvVoucherDetailList?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).forEach((x) => {
            x.TransportPrice = 0;
            x.TransportTax = 0;
            if (x.State === RowState.NoChange) x.State = RowState.Modify;
          });
          break;
      }
    }
    var sumTransportPrice = this.model?.InvVoucherDetailList?.getSumWithKey("TransportPrice");

    var sumTransportTax = this.model?.InvVoucherDetailList?.getSumWithKey("TransportTax");
    var temp = this.model?.InvVoucherDetailList?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached);
    var last = temp !== undefined && temp.length > 0 ? temp[temp.length - 1] : undefined;
    if (this.formGroup?.controls["TransportPrice"].value !== sumTransportPrice && last !== undefined) {
      last.TransportPrice = last.TransportPrice + (this.formGroup?.controls["TransportPrice"].value - sumTransportPrice);
    }
    if (this.formGroup?.controls["TransportTax"].value !== sumTransportTax) {
      last.TransportTax = last.TransportTax + (this.formGroup?.controls["TransportTax"].value - sumTransportTax);
    }
    ///به علت مشکل CanDelete
    // if (last && last.State === RowState.NoChange && this.model.StatusKindCode < InvStatusKind.Confirmed)
    //   last.State = RowState.Modify;
    if (this.formGroup?.controls["TransportPrice"].value === 0 || !this.formGroup?.controls["TransportPrice"].value) {
      this.model?.InvVoucherDetailList?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).forEach((x) => {
        x.TransportPrice = 0;
        x.TransportTax = 0;
        // if (x.State === RowState.NoChange && this.model?.StatusKindCode < InvStatusKind.Confirmed)
        //   x.State = RowState.Modify;
      });
    }
    if (this.formGroup?.controls["TransportInterfaceSharingKindCode"].value === 4) {
      this.model?.InvVoucherDetailList?.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached).forEach((x) => {
        x.TransportPrice = 0;
        x.TransportTax = 0;
        // if (x.State === RowState.NoChange)
        //   x.State = RowState.Modify;
      });
    }
  }

  setReferenceVoucherColumns() {
    this.httpCommonService
      .get("InvVoucherHeader/GetReferenceVoucherInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.selectorService.setColumns("ReferenceId", data as []);
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
  setStockInfoColumns() {
    this.httpCommonService
      .get("InvVoucherHeader/GetStockInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.StockInfoColumns = (data as form_control[]).filter((f) => (!f.areaName || f.areaName === "default") && f.listVisible);
            this.StockInfoColumns = this.StockInfoColumns.sort((a, b) => a.order - b.order);
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }

  async CreateVoucherKindReferencedTo(rvk: ReferenceVoucherKind) {
    if (rvk === null || rvk === undefined) {
      if (this.currentVoucherKind?.AutoCreateVoucherKindId !== undefined) {
        this.httpCommonService
          .getItem<InvVoucherKind>("InvVoucherKind", this.currentVoucherKind?.AutoCreateVoucherKindId)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            async (data) => {
              if (data !== null && data.IsWarehouse) await this.CreateInvVoucherReferencedTo(data);
            },
            (error) => this.getFailedHelper(error)
          );
      }
    }
    if (rvk !== null && rvk !== undefined) {
      await this.httpCommonService
        .getItem<InvVoucherKind>("InvVoucherKind", rvk.InvVoucherKindId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          async (data) => {
            if (data !== null && data.IsWarehouse) await this.CreateInvVoucherReferencedTo(data);
          },
          (error) => this.getFailedHelper(error)
        );
    }
  }
  async saveReferenceVoucher(model: any) {
    this.CreatedVoucherKindReferencedTo = true;
    if (!this.model.HasReferencedVoucherTo) {
      this.splashFormService.openDialog("", "در حال صدور سند معطوف");
      let apiName = this.apiName;
      if (model.SellVoucherDetailList && model.SellVoucherDetailList.length > 0) apiName = "SellVoucherHeader";
      await this.httpCommonService
        .create(apiName, model)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          async (row) => {
            this.splashFormService.closeLoading();
            this.tabsservice.tabItemonRefreshData.next(this.apiName);
            await this.ngOnInit();
            this.isRefreshingData = false;
            this.CreatedVoucherKindReferencedTo = false;
            this.sts.showToast("primary", "", "صند معطوف با موفقیت صادر شد.");
          },
          async (error) => {
            await this.ngOnInit();
            this.isRefreshingData = false;
            this.CreatedVoucherKindReferencedTo = false;
            this.saveFailedHelper(error);
            this.splashFormService.closeLoading();
            this.sts.showDialog(` خطا در صدور سند معطوف ${Utilities.getHttpResponseMessage(error)}`, "خطا");
          }
        );
    }
  }
  async CreateInvVoucherReferencedTo(vk: InvVoucherKind) {
    let flag: boolean = true;

    var refVoucher: any;
    if (vk.IsWarehouse !== true) refVoucher = <SellVoucherHeader>{};
    else refVoucher = <InvVoucherHeader>{};
    Object.keys(this.model).forEach((key) => {
      if (key !== "SendToInvDailyVoucher" && key !== "BasedOnBOM") refVoucher[key] = this.model[key];
    });
    if (vk.HasSubledger && vk.DefaultSubLedgerId) refVoucher.SubLedgerId = vk.DefaultSubLedgerId;
    else refVoucher.SubLedgerId = undefined;
    if (this.currentVoucherKind?.HasWarehouseTransfer) {
      refVoucher.WarehouseId = this.model.WarehouseTransferId;
      refVoucher.WarehouseCode = this.model.DetailLedgerCode;
      refVoucher.WarehouseTitle = this.model.DetailLedgerTitle;
      refVoucher.WarehouseTransferId = this.model.WarehouseId;
      refVoucher.WarehouseTransferCode = this.model.WarehouseCode;
      refVoucher.WarehouseTransferTitle = this.model.WarehouseTitle;
      refVoucher.DetailLedgerId = this.model.DetailLedgerId;
    }
    if (vk.HasOpositeParty === true && !this.formGroup?.get("DetailLedgerId")?.value) {
      this.sts.showDialog("برای صدور سند معطوف نیازبه طرف حساب دارد.", "صدور سند معطوف");
      return;
    }
    this.lookupservice
      .getLookupbyCode(
        vk.IsWarehouse === true ? "INV" : "SELL",
        "StatusKind",
        vk.FormOperationKindCode === FormOperationKind.IsPurchaseInvoice ? InvStatusKind.Registered : InvStatusKind.Confirmed
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (x) {
          refVoucher.StatusKindId = x.Id;
          refVoucher.StatusKindCode = x.Code;
          refVoucher.StatusKindTitle = x.Title;
        }
      });
    refVoucher.State = RowState.New;
    refVoucher.FiscalYearId = this.model.FiscalYearId;
    refVoucher.Id = 0;
    if (vk.IsWarehouse !== true) refVoucher.InvReferenceVoucherId = this.model.Id;
    else refVoucher.ReferenceVoucherId = this.model.Id;
    refVoucher.VoucherKindId = vk.Id;
    refVoucher.VoucherKindCode = vk.Code;
    refVoucher.VoucherKindTitle = vk.Title;
    refVoucher.IncrementalKindCode = vk.IncrementalKindCode;
    refVoucher.IncrementalKindTitle = vk.IncrementalKindTitle;
    refVoucher.ReferenceVoucherKindId = this.currentVoucherKind?.Id;
    refVoucher.ReferenceVoucherKindCode = this.currentVoucherKind?.Code;
    refVoucher.ReferenceVoucherKindTitle = this.currentVoucherKind?.Title;
    refVoucher.VoucherDate = this.model.VoucherDate;
    if (vk.IsWarehouse === true) refVoucher.InvVoucherDetailList = [];
    else refVoucher.SellVoucherDetailList = [];
    if (vk.IncrementalKindCode !== IncrementalKind.Decrement) {
      refVoucher.TotalPrice = this.model.TotalPrice;
      refVoucher.TotalDeduction = this.model.TotalDeduction;
      refVoucher.TotalSurplusage = this.model.TotalSurplusage;
    }
    if (this.model?.InvVoucherDetailList[0].Id <= 0) return;
    this.model?.InvVoucherDetailList?.filter((x) => x.Id != -1 && x.State !== RowState.Delete && x.State !== RowState.Detached).forEach((x) => {
      var vd: any;

      if (vk.IsWarehouse !== true) vd = <SellVoucherDetail>{};
      else vd = <InvVoucherDetail>{};
      Object.keys(x).forEach((key) => {
        vd[key] = x[key];
      });
      vd.BaseAmount = x.MainAmount;
      vd.RemainMainAmount = x.MainAmount;
      vd.State = RowState.New;
      vd.Id = 0;
      if (vk.IsWarehouse !== true) vd.InvReferenceId = x.Id;
      else vd.ReferenceId = x.Id;
      vd.ReferenceCode = this.model.VoucherNo;
      if (vk.IncrementalKindCode === IncrementalKind.Decrement) vd.UnitPrice = 0;

      if (
        (vk.IncrementalKindCode === IncrementalKind.Decrement || vk.ReserveBalance || vk.HasInventoryControl) &&
        this.missetup.getnumber("INV", "NegativeBalance")
      ) {
        let SaleAvailable: boolean = true;
      }
      if (
        !(vk.FormOperationKindCode === FormOperationKind.IsPurchaseInvoice || vk.FormOperationKindCode === FormOperationKind.IsReturnPurchaseInvoice)
      ) {
        vd.DiscountAmount = 0;
        vd.DiscountRate = 0;
        vd.Surplusage = 0;
        vd.Deduction = 0;
        vd.Tax = 0;
      }
      if (vk.IsWarehouse !== true) refVoucher.SellVoucherDetailList.push(vd);
      else refVoucher.InvVoucherDetailList.push(vd);
    });
    if (!flag) {
      this.sts.showDialog(
        "خطا در صدور سند معطوف.",
        "هشدار",
        DialogType.confirm,
        () => this.closeForm(true),
        () => this.closeForm(false)
      );
    } else await this.saveReferenceVoucher(refVoucher);
  }

  afterupdate() {
    super.afterupdate();
    this.afterDataLoaded.pipe(takeUntil(this.ngUnsubscribe)).subscribe(async (x) => {
      if (this.model.AccVoucherFixNumber > 0) return;
      if (x === true && !this.isRefreshingData) {
        this.isRefreshingData = true;
        if (this.currentVoucherKind?.AutoFocusedDocumentIssuance && this.currentVoucherKind?.AutoCreateVoucherKindId !== undefined) {
          if (!this.model.HasReferencedVoucherTo && this.CreatedVoucherKindReferencedTo === false) await this.CreateVoucherKindReferencedTo(null);
        } else if (this.currentVoucherKind?.HasJournalVoucher && this.currentVoucherKind?.HasJournalVoucherAuto) {
          if (this.model.StatusKindCode !== InvStatusKind.Confirmed) {
            this.lookupservice
              .getLookupbyCode("INV", "StatusKind", InvStatusKind.Confirmed)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((x) => {
                if (x) {
                  this.model.StatusKindId = x.Id;
                  this.model.StatusKindCode = x.Code;
                  this.model.StatusKindTitle = x.Title;
                  if (this.model.StatusKindCode === InvStatusKind.Confirmed) this.confirmLabel = "برگشت از تایید";
                  else this.confirmLabel = "تایید سند";
                  this.save();
                }
              });
          } else {
            let gridFilter: GridFilter[] = [];
            let InvVoucherHeaderIds: number[] = [];
            InvVoucherHeaderIds.push(this.model.Id);
            let filter: GridFilter = {
              Type: "F",
              Filed: "InvVoucherHeaderIds",
              Value: InvVoucherHeaderIds,
              Logic: "and",
              Operator: "eq",
              Skip: 0,
              Take: 0,
            };
            gridFilter.push(filter);
            if (!this.isDeleteCreatingAccVoucher) this.createAccVoucher(gridFilter);
            this.isDeleteCreatingAccVoucher = false;
          }
        }
      }
    });
  }
  closeForm(flag: boolean = false) {
    if (flag && !this.isNewVoucher) {
      if (this._id?.metadata?.id) {
        this.tabsservice.tabItemonRefreshData.next(this.apiName);
        this.tabsservice.tabItemOnCanClosing.next(this._id?.metadata?.id);
      }
      this.close();
    }
    if (this.isNewVoucher && flag) {
      this.selectorService.submitted$.next(false);
      this.model = undefined;
      this.currentrow = undefined;
      this.ngOnInit().then();
    }
    this.isClosing = false;
  }
  isCloseable() {
    this.selectorService.submitted$.next(false);
    this.formGroup?.markAsUntouched();
    this.currentrow = this.model;
    return false;
  }

  canDeactivate(): boolean | Observable<boolean> {
    if (
      !(
        (this.formGroup && this.formGroup?.dirty && this.formGroup?.touched) ||
        (this.model?.InvVoucherDetailList?.length > 0 &&
          this.model?.InvVoucherDetailList?.some((x) => (x.Id != -1 && x.State === RowState.New) || x.State === RowState.Modify))
      )
    )
      return true;
    this.sts.showDialog(
      "شما اطلاعات ذخیره نشده دارید! در صورت خروج اطلاعات از دست خواهد رفت.",
      "هشدار",
      DialogType.confirm,
      () => this.closeForm(true),
      () => this.closeForm(false)
    );
    return false;
  }

  submitButtonDisabled() {
    return this.model !== undefined && this.model.HasReferencedVoucherTo && !(this.formGroup?.touched && this.formGroup?.valid);
  }
  voucherConfirm() {
    // if (this.model.HasReferencedVoucherTo && this.model.StatusKindCode === InvStatusKind.Confirmed) {
    //   this.sts.showDialog("به علت وجود سند معطوف امکان حذف/ویرایش وجود ندارد.", "هشدار");
    //   return;
    // }
    // if(this.model.HasReferencedVoucherTo && this.model.StatusKindCode === InvStatusKind.Confirmed)
    // {
    //   this.sts.showDialog('به علت وجود سند معطوف قابل ویرایش نیست.', 'خطا در حذف اطلاعات');
    // }
    // else

    if (
      this.currentrow.ReferenceVoucherStatusKindCode == InvStatusKind.Calculated &&
      this.formGroup?.controls["StatusKindCode"].value === InvStatusKind.Confirmed
    ) {
      this.sts.showDialog("به علت وجود سند مبنا ریالی شده امکان برگشت از تایید وجود ندارد.", "هشدار");
      return;
    }
    if (
      this.isValid() &&
      (this.formGroup?.controls["StatusKindCode"].value === InvStatusKind.Registered ||
        this.formGroup?.controls["StatusKindCode"].value === InvStatusKind.Confirmed)
    ) {
      this.lookupservice
        .getLookupbyCode(
          "INV",
          "StatusKind",
          this.model.StatusKindCode === InvStatusKind.Confirmed ? InvStatusKind.Registered : InvStatusKind.Confirmed
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            if (this.formGroup?.controls["StatusKindCode"].value === InvStatusKind.Confirmed) {
              this.currentVoucherKind.HasAutoConfirm = false;
              this.currentVoucherKind.HasJournalVoucherAuto = false;
              this.currentVoucherKind.AutoFocusedDocumentIssuance = false;
            }
            this.model.StatusKindId = x.Id;
            this.model.StatusKindCode = x.Code;
            this.model.StatusKindTitle = x.Title;
            this.setValue("StatusKindId", x.Id);
            this.setValue("StatusKindCode", x.Code);
            this.setValue("StatusKindTitle", x.Title);
            if (this.model.StatusKindCode === InvStatusKind.Confirmed) this.confirmLabel = "برگشت از تایید";
            else {
              if (this.model?.InvVoucherDetailList && this.model.InvVoucherDetailList.length > 0) {
                this.onValueChanges(this.model.InvVoucherDetailList[0]);
                this.erroremessage = undefined;
              }
              this.confirmLabel = "تایید سند";
            }
            //if (!this.isloading)
            this.save();
            //else
            //  this.stockListLoaded
            //    .pipe(takeUntil(this.ngUnsubscribe))
            //    .subscribe(x => {
            //      if (x && !this.isSaving && this.model.StatusKindCode === InvStatusKind.Registered)
            //        this.save();
            //    });
            this.cd.markForCheck();
          }
        });
    }
  }
  delete_Voucher() {
    this.sts.showToast("primary", "", "در حال حذف...");
    this.httpCommonService
      .delete(this.apiName, this.model.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        async (results) => {
          this.sts.showToast("success", "", "اطلاعات با موفیت حذف شد.");
          this.model = undefined;
          this.currentrow = undefined;
          this.OrignalDetail = [];
          this.currentVoucherKind.HasJournalVoucherAuto = false;
          this.currentVoucherKind.AutoFocusedDocumentIssuance = false;
          await this.ngOnInit();
        },
        (error) => {
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف اطلاعات");
        }
      );
  }
  deleteVoucher() {
    this.sts.showDialog(`آیا از حذف سند اطمینان دارید؟`, "حذف سند", DialogType.confirm, () => this.delete_Voucher());
  }
  async newVoucher() {
    this.isNewVoucher = true;
    if (this.canDeactivate()) {
      this.isClosing = false;
      this.selectorService.submitted$.next(false);
      this.model = {} as any;
      this.OrignalDetail = [];
      this.currentrow = undefined;
      this.cd.markForCheck();
      await this.ngOnInit();
    }
  }

  async voucherRefrenceTo() {
    if (!this.model.HasReferencedVoucherTo) await this.CreateVoucherKindReferencedTo(null);
    else this.erroremessage = "برای این سند قبلا معطوف صادر شده است.";
  }
  accountAccVoucher(create: boolean = true) {
    if (create && this.model.StatusKindCode < InvStatusKind.Confirmed) {
      this.sts.showDialog(`سند تایید نشده است.`, "خطا");
      return;
    }
    if (this.model.StatusKindCode >= InvStatusKind.Confirmed) {
      let gridFilter: GridFilter[] = [];
      let InvVoucherHeaderIds: number[] = [];
      InvVoucherHeaderIds.push(this.model.Id);
      let filter: GridFilter = {
        Type: "F",
        Filed: "InvVoucherHeaderIds",
        Value: InvVoucherHeaderIds,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 0,
      };
      gridFilter.push(filter);
      if (this.model.AccVoucherFixNumber !== undefined && this.model.AccVoucherFixNumber > 0 && !create) {
        this.deleteAccVoucher(gridFilter);
      }
      if (create && (this.model.StatusKindCode === InvStatusKind.Confirmed || this.model.StatusKindCode === InvStatusKind.Calculated))
        this.createAccVoucher(gridFilter);
    }
  }
  createAccVoucher(gridFilter: GridFilter[]) {
    if (this.isCreatingAccVoucher === true) return;
    this.isCreatingAccVoucher = true;
    this.splashFormService.openDialog("", "در حال صدور سند حسابداری");
    this.httpCommonService
      .create(this.apiName + "/CreateAccVoucher", gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        async (x) => {
          if (x) {
            this.splashFormService.closeLoading();
            this.tabsservice.tabItemonRefreshData.next(this.apiName);
            this.sts.showDialog("سند با موفقیت صادر شد.", "");
            this.accVoucherCaption = "حذف سند حسابداری";
            await this.ngOnInit();
            this.isRefreshingData = false;
            this.isCreatingAccVoucher = false;
          }
        },
        async (error) => {
          this.isRefreshingData = false;
          this.currentVoucherKind.HasJournalVoucherAuto = false;
          await this.ngOnInit();
          this.splashFormService.closeLoading();
          this.sts.showDialog(`خطا در صدور اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا");
          this.isCreatingAccVoucher = false;
        }
      );
  }
  deleteAccVoucher(gridFilter: GridFilter[]) {
    this.isDeleteCreatingAccVoucher = true;
    this.splashFormService.openDialog("", "در حال حذف سند حسابداری");
    this.currentVoucherKind.HasJournalVoucherAuto = false;
    this.httpCommonService
      .create(this.apiName.split("/")[0] + "/DeleteAccVoucher", gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        async (x) => {
          if (x) {
            this.splashFormService.closeLoading();
            this.currentVoucherKind.HasJournalVoucherAuto = false;
            this.tabsservice.tabItemonRefreshData.next(this.apiName);
            this.sts.showDialog("سند با موفقیت حذف شد.", "");
            this.accVoucherCaption = "سند حسابداری";
            this.isCloseable();
            await this.ngOnInit();
            this.isRefreshingData = false;
            this.isCreatingAccVoucher = false;
            this.cd.markForCheck();
          }
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(`خطا در حذف اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }
  viewAccVoucher() {
    this.httpCommonService
      .getItem(this.apiName + "/ViewAccVoucher", this.model.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          var datatrasfer: Datatransfer = <Datatransfer>{};
          datatrasfer.apiName = this.apiName;
          datatrasfer.label = "سند حسابداری";
          datatrasfer.areaName = "Accounting";
          datatrasfer.currentrow = x;
          const menu = <ITab>{
            title: `سند حسابداری-(نمایش)`,
            isCloseable: true,
            active: true,
            responsive: true,
            componentType: AccVoucherFormComponent,
            // modulePath: this.tabsservice.getActiveTab().modulePath,
            data: [
              { provide: EntityBase, useValue: x },
              { provide: Datatransfer, useValue: datatrasfer },
              { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: x[""] } },
            ],
          };
          this.tabsservice.open(menu);
        },
        (error) => this.sts.showDialog(`خطا در نمایش سند:${Utilities.getHttpResponseMessage(error)}`, "خطا")
      );
  }
  deleteRowsWithoutValues() {
    this.model?.InvVoucherDetailList?.forEach((x) => {
      if (!x.Amount || x.Amount <= 0) {
        if (x.State === RowState.New) x.State = RowState.Detached;
        else x.State = RowState.Delete;
      }
    });
  }

  DelteZeroAmount() {
    this.model?.InvVoucherDetailList?.forEach((item) => {
      if (item.Amount == 0) {
        if (item.State === RowState.New) item.State = RowState.Detached;
        else item.State = RowState.Delete;
      }
    });
  }
  GetGoodsFormulaDetail() {
    var filters: GridFilter[] = [];
    let voucherdate: Date = this.formGroup?.get("VoucherDate")?.value;
    if (isNullOrUndefined(voucherdate)) {
      if (!this.model.VoucherDate) voucherdate = new Date();
      else voucherdate = this.model.VoucherDate;
    }
    if (this.formGroup && this.formGroup?.get("VoucherDate")?.value) this.model.VoucherDate = this.formGroup?.get("VoucherDate")?.value;
    filters.push({ Filed: "EffectDate", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: this.model?.VoucherDate, Logic: "and" });

    this.httpCommonService
      .create("InvVoucherHeader/GetGoodsFormulaDetail", filters)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: GoodsFormulaDetail[]) => {
          this.goodsFormulaDetailList = data;
        },
        (error) => this.getFailedHelper(error)
      );
  }
  ReplaceGoodsSimilar() {
    if (!this.model?.InvVoucherDetailList?.some((x) => x.HasError)) return;

    let editableList: InvVoucherDetail[] = [];
    if (this.goodsFormulaDetailList == null || this.goodsFormulaDetailList.length <= 0) {
      this.GetGoodsFormulaDetail();
    }
    this.getStockList()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (stock: PagingDataResult<StockInfo>) => {
          let PrevAmount: number = 0;
          let _stockList = stock.Data as StockInfo[];
          let PrevGoodsId: number = 0;
          this.model?.InvVoucherDetailList?.filter((x) => x.HasError)
            .sort((a, b) => a.GoodsId - b.GoodsId)
            .forEach((entity) => {
              if (PrevGoodsId != entity.GoodsId) PrevAmount = 0;
              var OrignalSaleAvailable = _stockList.some(
                (x) => x.WarehouseId === this.formGroup?.get("WarehouseId")?.value && x.GoodsId === entity.GoodsId
              )
                ? _stockList.find((x) => x.WarehouseId === this.formGroup?.get("WarehouseId")?.value && x.GoodsId === entity.GoodsId).StockAmount
                : 0;
              var SaleAvailable = OrignalSaleAvailable - PrevAmount;
              let RemainAmount = entity.MainAmount;
              let CurrentAmount = 0;

              if (SaleAvailable <= 0) {
                while (RemainAmount > 0) {
                  var GoodsFormulaDetail = this.goodsFormulaDetailList.find(
                    (x) => x.GoodsId == entity.GoodsId && x.HeaderGoodsId == entity.BaseGoodsId
                  );
                  if (GoodsFormulaDetail != null) {
                    var GoodsSimilar = GoodsFormulaDetail.GoodsSimilars;
                    if (GoodsSimilar != null && GoodsSimilar.length > 0) {
                      RemainAmount = entity.MainAmount;
                      entity.MainAmount = 0;
                      entity.Amount = 0;
                      GoodsSimilar.forEach((gs) => {
                        var CurrentSimarValue = editableList.some((x) => x.GoodsId == gs.GoodsId) ? editableList?.getSumWithKey("MainAmount") : 0;
                        CurrentSimarValue = this.model?.InvVoucherDetailList?.some((x) => x.GoodsId == gs.GoodsId)
                          ? this.model?.InvVoucherDetailList?.getSumWithKey("StandardValue")
                          : 0;
                        let gsRemainAmount = RemainAmount;
                        if (gs.StandardAmount !== undefined) gsRemainAmount = (RemainAmount * gs.StandardAmount) / GoodsFormulaDetail.StandardAmount;
                        SaleAvailable = _stockList.some(
                          (x) => x.WarehouseId === this.formGroup?.get("WarehouseId")?.value && x.GoodsId === gs.GoodsId
                        )
                          ? _stockList.find((x) => x.WarehouseId === this.formGroup?.get("WarehouseId")?.value && x.GoodsId === gs.GoodsId)
                              .StockAmount - CurrentSimarValue
                          : 0;
                        if (SaleAvailable > 0) {
                          if (gsRemainAmount > SaleAvailable) CurrentAmount = SaleAvailable;
                          else CurrentAmount = gsRemainAmount;
                          gsRemainAmount = gsRemainAmount - CurrentAmount;
                          RemainAmount = (gsRemainAmount * GoodsFormulaDetail.StandardAmount) / gs.StandardAmount;
                          if (CurrentAmount > 0) {
                            var row = Object.assign({}, entity);
                            row.InvVoucherHeaderId = this.model.Id ?? 0;
                            row.MainAmount = CurrentAmount;
                            row.GoodsUnitRatio = entity.GoodsUnitRatio;
                            row.Amount = row.MainAmount / row.GoodsUnitRatio;
                            row.BaseGoodsId = entity.BaseGoodsId;
                            row.IsGoods = entity.IsGoods;
                            row.BaseAmount = entity.BaseAmount;
                            row.GoodsId = gs.GoodsId;
                            row.GoodsCode = gs.GoodsCode;
                            row.GoodsTitle = gs.GoodsTitle;
                            row.GoodsUnitId = gs.GoodsUnitId;
                            row.GoodsUnitTitle = gs.UnitTitle;
                            row.PriceUnitId = gs.GoodsUnitId;
                            row.PriceUnitTitle = gs.UnitTitle;
                            row.StandardValue = CurrentAmount;
                            row.ReferenceCode = entity.ReferenceCode;
                            row.ReferenceId = entity.ReferenceId;
                            row.UnitPrice = 0;
                            row.Price = 0;
                            row.OrignalAmount = 0;
                            row.OrignalMainAmount = 0;
                            row.DiscountRate = 0;
                            row.DiscountAmount = 0;
                            row.TotalPrice = 0;
                            row.FirstOutAmount = 0;
                            row.TransportPrice = 0;
                            row.TransportTax = 0;
                            row.RemainMainAmount = 0;
                            row.StockAmount = 0;
                            row.SumSaleAmount = 0;
                            row.SumInventoryAmount = 0;
                            row.SumReserveAmount = 0;
                            row.SaleAvailable = 0;
                            row.DefaultStockAmount = 0;
                            row.DefaultSumSaleAmount = 0;
                            row.DefaultSumInventoryAmount = 0;
                            row.DefaultSumReserveAmount = 0;
                            row.DefaultSaleAvailable = 0;
                            row.HasReferencedVoucherTo = false;
                            row.State = RowState.New;
                            row.Id = 0;
                            row.Comment = `جایگزین کالای کد(${entity.GoodsCode})  عنوان (${entity.GoodsTitle})`;
                            editableList.push(row);
                          }
                          SaleAvailable = 0;
                        }
                      });
                      entity.Amount += RemainAmount;
                      entity.MainAmount = entity.Amount * entity.GoodsUnitRatio;
                      entity.StandardValue = entity.Amount * entity.GoodsUnitRatio;
                      RemainAmount = 0;
                    } else {
                      RemainAmount = 0;
                    }
                  } else {
                    RemainAmount = 0;
                  }
                }
              }

              if (SaleAvailable > 0) {
                entity.StandardValue = Object.assign({}, entity).MainAmount;
                CurrentAmount =
                  OrignalSaleAvailable - PrevAmount > 0 && entity.MainAmount >= OrignalSaleAvailable - PrevAmount
                    ? OrignalSaleAvailable - PrevAmount
                    : entity.MainAmount;
                RemainAmount = entity.MainAmount - CurrentAmount;
                entity.Amount = 0;
                entity.MainAmount =
                  OrignalSaleAvailable - PrevAmount > 0 && entity.MainAmount >= OrignalSaleAvailable - PrevAmount
                    ? OrignalSaleAvailable - PrevAmount
                    : entity.MainAmount;
                entity.Amount = entity.MainAmount / entity.GoodsUnitRatio;
                PrevAmount += entity.MainAmount;
                while (RemainAmount > 0) {
                  let GoodsFormulaDetail = this.goodsFormulaDetailList.find(
                    (x) => x.GoodsId == entity.GoodsId && x.HeaderGoodsId == entity.BaseGoodsId
                  );
                  if (GoodsFormulaDetail != null) {
                    var GoodsSimilar = GoodsFormulaDetail.GoodsSimilars;
                    if (GoodsSimilar !== null && GoodsSimilar.length > 0) {
                      GoodsSimilar.forEach((gs) => {
                        var CurrentSimarValue = editableList.some((x) => x.GoodsId == gs.GoodsId) ? editableList?.getSumWithKey("MainAmount") : 0;
                        let gsRemainAmount = RemainAmount;
                        if (gs.StandardAmount !== undefined) gsRemainAmount = (RemainAmount * gs.StandardAmount) / GoodsFormulaDetail.StandardAmount;
                        SaleAvailable =
                          _stockList.find((x) => x.WarehouseId === this.formGroup?.get("WarehouseId")?.value && x.GoodsId === gs.GoodsId)
                            .StockAmount - CurrentSimarValue;
                        if (SaleAvailable > 0) {
                          if (gsRemainAmount > SaleAvailable) CurrentAmount = SaleAvailable;
                          else CurrentAmount = gsRemainAmount;
                          gsRemainAmount = gsRemainAmount - CurrentAmount;
                          RemainAmount = (gsRemainAmount * GoodsFormulaDetail.StandardAmount) / gs.StandardAmount;
                          if (CurrentAmount > 0) {
                            var row = <InvVoucherDetail>{};
                          }
                          row.MainAmount = CurrentAmount;
                          row.GoodsUnitRatio = entity.GoodsUnitRatio;
                          row.IsGoods = entity.IsGoods;
                          row.BaseAmount = entity.BaseAmount;
                          row.Amount = row.MainAmount / row.GoodsUnitRatio;
                          row.BaseGoodsId = entity.BaseGoodsId;
                          row.GoodsId = gs.GoodsId;
                          row.GoodsCode = gs.GoodsCode;
                          row.GoodsTitle = gs.GoodsTitle;
                          row.GoodsUnitId = gs.GoodsUnitId;
                          row.GoodsUnitTitle = gs.UnitTitle;
                          row.StandardValue = CurrentAmount;
                          row.ReferenceCode = entity.ReferenceCode;
                          row.ReferenceId = entity.ReferenceId;
                          row.Comment = `جایگزین کالای کد(${entity.GoodsCode})  عنوان (${entity.GoodsTitle})`;
                          editableList.push(row);
                        }
                        SaleAvailable = 0;
                      });
                      if (RemainAmount <= 0) break;
                    }
                    entity.Amount += RemainAmount;
                    entity.MainAmount = entity.Amount * entity.GoodsUnitRatio;
                    entity.StandardValue = entity.Amount * entity.GoodsUnitRatio;
                    RemainAmount = 0;
                  } else {
                    entity.Amount += RemainAmount;
                    entity.MainAmount = entity.Amount * entity.GoodsUnitRatio;
                    entity.StandardValue = entity.Amount * entity.GoodsUnitRatio;
                    RemainAmount = 0;
                  }
                }
              } else {
                RemainAmount = 0;
              }
              PrevGoodsId = entity.GoodsId;
            });
          editableList.forEach((item) => {
            this.model?.InvVoucherDetailList?.push(item);
          });
          this.DelteZeroAmount();
          if (this.currentVoucherKind?.IncrementalKindCode == 2 && this.currentVoucherKind?.BasedOnBOM) this.SetInvVoucherGoodsSimilar();
          this.SetGoodsGroupBy();

          this.isFristReplaceGoodsSimilar = false;
          this.cd.markForCheck();
        },
        (error) => {
          this.getFailedHelper(error);
        }
      );
  }
  SetGoodsGroupBy() {
    let VoucherDetails: InvVoucherDetail[];
    if (this.currentVoucherKind?.IsGroupByWithGoods) {
      VoucherDetails = Object.assign([], this.detail.dataList);
      this.model.InvVoucherDetailList = [];
    }
    if (
      this.currentVoucherKind?.IsGroupByWithGoods &&
      !this.missetup.getboolean("INV", "IsGroupByWithGoods") &&
      this.currentVoucherKind?.IncrementalKindCode !== IncrementalKind.Neutral
    ) {
      VoucherDetails.forEach((entity) => {
        if (
          !this.model?.InvVoucherDetailList?.some(
            (x) =>
              x.IsGoods === entity.IsGoods &&
              x.BaseGoodsId === entity.BaseGoodsId &&
              x.GoodsId === entity.GoodsId &&
              x.GoodsUnitId == entity.GoodsUnitId &&
              x.Comment === entity.Comment
          )
        ) {
          const detail = VoucherDetails?.filter(
            (x) =>
              x.IsGoods === entity.IsGoods &&
              x.BaseGoodsId === entity.BaseGoodsId &&
              x.GoodsId === entity.GoodsId &&
              x.GoodsUnitId == entity.GoodsUnitId &&
              x.Comment === entity.Comment
          );
          entity.Amount = detail?.getSumWithKey("Amount");
          entity.BaseAmount = detail?.getSumWithKey("BaseAmount");
          entity.Deduction = detail?.getSumWithKey("Deduction");
          entity.DiscountAmount = detail?.getSumWithKey("DiscountAmount");
          entity.DiscountRate = detail?.getSumWithKey("DiscountRate");
          entity.RemainAmount = detail?.getSumWithKey("RemainAmount");
          entity.RemainMainAmount = detail?.getSumWithKey("RemainMainAmount");
          entity.Surplusage = detail?.getSumWithKey("Surplusage");
          entity.Tax = detail?.getSumWithKey("Tax");
          entity.UnitPrice = this.currentVoucherKind?.IncrementalKindCode == 2 ? 0 : detail?.getSumWithKey("UnitPrice");
          entity.FirstOutAmount = this.currentVoucherKind?.IncrementalKindCode == 2 ? 0 : detail?.getSumWithKey("FirstOutAmount");
          entity.PreRemainAmount = this.currentVoucherKind?.IncrementalKindCode == 2 ? 0 : detail?.getSumWithKey("PreRemainAmount");
          this.model?.InvVoucherDetailList?.push(entity);
        }
      });
    }
    if (
      this.currentVoucherKind?.IsGroupByWithGoods &&
      this.missetup.getboolean("INV", "IsGroupByWithGoods") &&
      this.currentVoucherKind?.IncrementalKindCode === IncrementalKind.Neutral
    ) {
      VoucherDetails.forEach((entity) => {
        if (
          !this.model?.InvVoucherDetailList?.some(
            (x) => x.IsGoods === entity.IsGoods && x.GoodsId === entity.GoodsId && x.GoodsUnitId == entity.GoodsUnitId && x.Comment === entity.Comment
          )
        ) {
          const detail = VoucherDetails?.filter(
            (x) => x.IsGoods === entity.IsGoods && x.GoodsId === entity.GoodsId && x.GoodsUnitId == entity.GoodsUnitId && x.Comment === entity.Comment
          );
          entity.Amount = detail?.getSumWithKey("Amount");
          entity.BaseAmount = detail?.getSumWithKey("BaseAmount");
          entity.Deduction = detail?.getSumWithKey("Deduction");
          entity.DiscountAmount = detail?.getSumWithKey("DiscountAmount");
          entity.DiscountRate = detail?.getSumWithKey("DiscountRate");
          entity.RemainAmount = detail?.getSumWithKey("RemainAmount");
          entity.RemainMainAmount = detail?.getSumWithKey("RemainMainAmount");
          entity.Surplusage = detail?.getSumWithKey("Surplusage");
          entity.Tax = detail?.getSumWithKey("Tax");
          entity.UnitPrice = this.currentVoucherKind?.IncrementalKindCode == 2 ? 0 : detail?.getSumWithKey("UnitPrice");
          entity.FirstOutAmount = this.currentVoucherKind?.IncrementalKindCode == 2 ? 0 : detail.getSumWithKey("FirstOutAmount");
          entity.PreRemainAmount = this.currentVoucherKind?.IncrementalKindCode == 2 ? 0 : detail?.getSumWithKey("PreRemainAmount");
          this.model?.InvVoucherDetailList?.push(entity);
        }
      });
    }
    if (this.currentVoucherKind?.IsGroupByWithGoods) this.detail.dataList = this.model?.InvVoucherDetailList;
    this.detail.setRowNumber();
    let model = Object.assign({}, this.filterEntity);
    if (this.model?.InvVoucherDetailList?.length > 1) model["VoucherNo"] = this.model?.InvVoucherDetailList[1].ReferenceCode;
    if (this.currentVoucherKind?.HasWarehouseTransfer) {
      model.WarehouseTransferId = this.filterEntity.WarehouseId;
      model.WarehouseId = this.filterEntity.WarehouseTransferId;
    }
    this.httpCommonService
      .create("InvVoucherHeader/GetVoucherByVoucherKind", model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          if (x && x?.length > 0) {
            const voucher = x[0];
            this.setValue("WarehouseId", voucher.WarehouseId);
            this.setValue("VoucherDate", voucher.VoucherDate);
            this.setValue("DetailLedgerId", voucher.DetailLedgerId);
            this.isloading = false;
            this.model.InvVoucherDetailList = this.model.InvVoucherDetailList.filter((f) => f.Id != -1);
            this.onValueChanges(this.model.InvVoucherDetailList[0]);
          }
        },
        (error) => {}
      );
    console.log();
  }
  SetInvVoucherGoodsSimilar() {
    if (!this.model.InvVoucherGoodsSimilarRelationList) this.model.InvVoucherGoodsSimilarRelationList = [];
    this.model?.InvVoucherDetailList?.forEach((item) => {
      if (
        !this.model.InvVoucherGoodsSimilarRelationList.some(
          (x) => x.SimilarGoodsId == item.GoodsId && x.GoodsId == (item.BaseGoodsId !== undefined ? item.BaseGoodsId : item.GoodsId)
        )
      ) {
        if (item.StandardValue == 0 && item.MainAmount > 0) item.StandardValue = item.MainAmount;
        if (item.StandardValue > 0) {
          var entity = <InvVoucherGoodsSimilarRelation>{};
          var item2 = Object.assign({}, item);
          entity.InvVoucherHeaderId = this.model.Id ?? 0;
          entity.GoodsId = item2.BaseGoodsId !== undefined ? item2.BaseGoodsId : item2.GoodsId;
          entity.SimilarGoodsId = item2.GoodsId;
          entity.StandardAmount = item2.StandardValue;
          this.model.InvVoucherGoodsSimilarRelationList.push(entity);
        }
      } else {
        var similar = this.model.InvVoucherGoodsSimilarRelationList.find(
          (x) => x.SimilarGoodsId == item.GoodsId && x.GoodsId == (item.BaseGoodsId !== undefined ? item.BaseGoodsId : item.GoodsId)
        );
        if (similar != null && similar.StandardAmount != item.StandardValue && item.StandardValue != 0) {
          similar.StandardAmount = item.StandardValue;
        }
      }
    });
  }
  PriceRefresh() {
    if (!this.model.InvVoucherDetailList || this.model?.InvVoucherDetailList?.length <= 0) return;
    this.beforupdate();
    this.httpCommonService
      .create("InvVoucherHeader/GetGoodsBOMPrice", this.getDataFromFormGroup())
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: InvVoucherHeader) => {
          this.model = data;
        },
        (error) => this.getFailedHelper(error)
      );
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.selectorService.setDataStateChange("DetailLedgerId", undefined);
    this.currentVoucherKind = undefined;
    this.StockInfoColumns = undefined;
    this.InvVoucherDetailColumns = undefined;
    this.rightSideColumns = undefined;
    this.bodyColumns = undefined;
    this.subLedgerColumns = undefined;
    this.DiscountColumns = undefined;
    this.leftSideColumns = undefined;
    this.stockList = undefined;
    this.filterdDataList = undefined;
    this.goodsFormulaDetailList = undefined;
    this.ReportGoodsFormulaDetailList = undefined;
    this.CurrentGoodsList = undefined;
    this.reportList = undefined;
    this.isFristReplaceGoodsSimilar = undefined;
    this.footerColumns = undefined;
    this.transportColumns = undefined;
  }
  loadVoucherList() {
    this.inputEditorform = InvVoucherModalListComponent;
    this.dialogService
      .open(
        this.inputEditorform,
        {
          label: this.label,
          currentVoucherKindId: this.currentVoucherKind?.Id,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (model) => {
        if (model) {
          if (this.detail) this.detail.cancelHandler();
          this.currentrow = model;
          this.id = this.currentrow.Id;
          await this.ngOnInit();
        }
      });
  }

  changeReport(reprtName: string) {
    super.changeReport(reprtName);
    this.currentReport = undefined;
  }
  onReferenceVoucherChange(entity: any) {
    if (this.currentVoucherKind?.HasWarehouseTransfer && !this.formGroup?.get("WarehouseTransferId")?.value) {
      this.model.WarehouseTransferId = entity.WarehouseId;
      this.model.WarehouseTransferCode = entity.WarehouseCode;
      this.model.WarehouseTransferTitle = entity.WarehouseTitle;
      this.setValue("WarehouseTransferId", this.model.WarehouseTransferId);
      this.setValue("WarehouseTransferCode", this.model.WarehouseTransferCode);
      this.setValue("WarehouseTransferTitle", this.model.WarehouseTransferTitle);
    } else if (
      (!this.formGroup?.get("DetailLedgerId")?.value || this.currentVoucherKind?.NoChangeRefereWarehouseDetailLedger === true) &&
      entity.DetailLedgerId
    ) {
      this.model.DetailLedgerId = entity.DetailLedgerId;
      this.model.DetailLedgerCode = entity.DetailLedgerCode;
      this.model.DetailLedgerTitle = entity.DetailLedgerTitle;
      this.setValue("DetailLedgerId", this.model.DetailLedgerId);
      this.setValue("DetailLedgerCode", this.model.DetailLedgerCode);
      this.setValue("DetailLedgerTitle", this.model.DetailLedgerTitle);
    }

    if (
      (this.currentVoucherKind?.HasWarehouseTransfer && this.currentVoucherKind?.IncrementalKindCode == IncrementalKind.Increment) ||
      (this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseInvoice &&
        this.currentVoucherKind?.IncrementalKindCode == IncrementalKind.Debtor)
    ) {
      this.model.VoucherDate = entity.VoucherDate;
      this.setValue("VoucherDate", this.model.VoucherDate);
    }
    if (
      this.currentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseInvoice &&
      this.currentVoucherKind?.IncrementalKindCode == IncrementalKind.Debtor &&
      (!this.formGroup?.get("WarehouseId")?.value || this.currentVoucherKind?.NoChangeRefereWarehouseDetailLedger === true)
    ) {
      this.model.WarehouseId = entity.WarehouseId;
      this.model.WarehouseCode = entity.WarehouseCode;
      this.model.WarehouseTitle = entity.WarehouseTitle;
      this.setValue("WarehouseId", this.model.WarehouseId);
      this.setValue("WarehouseCode", this.model.WarehouseCode);
      this.setValue("WarehouseTitle", this.model.WarehouseTitle);
    }
  }
  onvalueChangeWithName($event) {
    if ($event && $event?.name === "TotalDiscount" && $event.value) {
      this.model.InvVoucherDetailList.forEach((x) => {
        x.DiscountRate = $event.value;
        this.detail?._setChanges(x);
      });
    }
    this.setSummery();
    this.cd.markForCheck();
  }
}
